<template>
  <div>
    <div v-show="post_datail" class="DetailWithShow">
      <div class="accommodation-pdp-head accommodation-pdp__head">
        <div class="title">
          <div class="titleWrapper">
            <h1>
              {{ post_datail?.content }}
            </h1>
            <div class="uploadedDate">
              {{ post_datail?.created_fa }}
            </div>
          </div>
          <div class="specifications">
            <a class="all-center text-underline">
              <strong class="city-province">
                {{ post_datail?.address }}
              </strong>
            </a>
          </div>
        </div>

        <div class="actions">
          <button
            @click="save_favorit(post_datail?.id)"
            class="share-btn all-center share"
          >
            <svg
              v-if="post_datail"
              xmlns="http://www.w3.org/2000/svg"
              width="26px"
              height="26px"
              :fill="post_datail.is_favorite == 1 ? 'none' : '#0096c7'"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="#0096c7"
              class="size-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z"
              />
            </svg>

            <div class="vertical-separator"></div>
            <span class="share-btn-text">ذخیره </span>
          </button>

          <button @click="shareContent" class="share-btn all-center share">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26px"
              height="26px"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="#0096c7"
              class="size-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
              />
            </svg>

            <div class="vertical-separator"></div>
            <span class="share-btn-text">اشتراک </span>
          </button>

          <div class="favorite-widget">
            <button
              @click="save_like(post_datail?.id)"
              class="fav-btn all-center"
            >
              <VsxIcon
                v-if="post_datail && post_datail.is_like == 1"
                iconName="Heart"
                :size="28"
                color="#0096c7"
                type="linear"
              />
              <VsxIcon
                v-if="post_datail && post_datail.is_like == 2"
                iconName="Heart"
                :size="28"
                color="red"
                type="bold"
              />
              <div class="vertical-separator"></div>
              <span> مورد علاقه‌ </span>
            </button>
          </div>
        </div>
      </div>

      <detailsImage
        v-if="post_datail"
        :data="post_datail"
        :comment_count="post_datail?.comments_count"
        :contentShare="shareContent"
        :saveFavorite="save_favorit"
        :saveLike="save_like"
        :showComments="OpenMessage"
        :likeLoading="likeLoading"
        style="margin-top: 1rem"
      />
      <div class="accommodation-pdp-content">
        <div class="accommodation-pdp-content__main">
          <section
            style="align-items: center !important"
            class="pdp-host-info mobileTitle"
          >
            <div class="postTitleContainer">
              <h1 class="postTitle">
                {{ post_datail?.content }}
              </h1>
              <div class="postPrice">
                <div class="postPriceWrapper">
                  <div
                    v-if="
                      post_datail && post_datail.main_category_en == 'trade'
                    "
                  >
                    <span
                      style="margin-left: 4px"
                      v-if="
                        post_datail && post_datail.main_category_en == 'trade'
                      "
                    >
                      قیمت :</span
                    >
                    <strong
                      v-if="
                        post_datail && post_datail.main_category_en == 'trade'
                      "
                    >
                      {{ post_datail?.total_price }}
                    </strong>
                  </div>

                  <div
                    class="requestPrice"
                    v-if="
                      post_datail &&
                      post_datail.main_category_en == 'request' &&
                      post_datail.request_type_en == 'buy'
                    "
                  >
                    <span
                      style="margin-left: 4px"
                      v-if="
                        post_datail &&
                        post_datail.main_category_en == 'request' &&
                        post_datail.request_type_en == 'buy'
                      "
                    >
                      قیمت :</span
                    >
                    <strong
                      v-if="
                        post_datail &&
                        post_datail.main_category_en == 'request' &&
                        post_datail.request_type_en == 'buy'
                      "
                    >
                      <span>از {{ post_datail?.total_price }}</span>
                      <span>تا {{ post_datail?.total_price_max }}</span>
                    </strong>
                  </div>
                  <div
                    v-if="post_datail && post_datail.main_category_en == 'rent'"
                  >
                    <span
                      style="margin-left: 4px"
                      v-if="
                        post_datail && post_datail.main_category_en == 'rent'
                      "
                    >
                      مبلغ رهن:</span
                    >
                    <strong
                      v-if="
                        post_datail && post_datail.main_category_en == 'rent'
                      "
                    >
                      {{ post_datail?.mortgage_price }}
                    </strong>
                  </div>

                  <div
                    class="requestPriceRent"
                    v-if="
                      post_datail &&
                      post_datail.main_category_en == 'request' &&
                      post_datail.request_type_en == 'rent'
                    "
                  >
                    <span
                      style="margin-left: 4px"
                      v-if="
                        post_datail &&
                        post_datail.main_category_en == 'request' &&
                        post_datail.request_type_en == 'rent'
                      "
                    >
                      مبلغ رهن:</span
                    >
                    <strong
                      v-if="
                        post_datail &&
                        post_datail.main_category_en == 'request' &&
                        post_datail.request_type_en == 'rent'
                      "
                    >
                      <span>از {{ post_datail?.mortgage_price }}</span>
                      <span>تا {{ post_datail?.mortgage_price_max }}</span>
                    </strong>
                  </div>
                  <div
                    v-if="post_datail && post_datail.main_category_en == 'rent'"
                  >
                    <span
                      style="margin-left: 4px"
                      v-if="
                        post_datail && post_datail.main_category_en == 'rent'
                      "
                    >
                      مبلغ اجاره:</span
                    >
                    <strong
                      v-if="
                        post_datail && post_datail.main_category_en == 'rent'
                      "
                    >
                      {{ post_datail?.rent_price }}
                    </strong>
                  </div>
                  <div
                    class="requestPriceRent"
                    v-if="
                      post_datail &&
                      post_datail.main_category_en == 'request' &&
                      post_datail.request_type_en == 'rent'
                    "
                  >
                    <span
                      style="margin-left: 4px"
                      v-if="
                        post_datail &&
                        post_datail.main_category_en == 'request' &&
                        post_datail.request_type_en == 'rent'
                      "
                    >
                      مبلغ اجاره:</span
                    >
                    <strong
                      v-if="
                        post_datail &&
                        post_datail.main_category_en == 'request' &&
                        post_datail.request_type_en == 'rent'
                      "
                    >
                      <span>از {{ post_datail?.rent_price }}</span>
                      <span>تا {{ post_datail?.rent_price_max }}</span>
                    </strong>
                  </div>
                </div>
                <div class="uploadedDate">
                  {{ post_datail?.created_fa }}
                </div>
              </div>
            </div>
          </section>
          <section
            style="align-items: center !important"
            class="pdp-host-info postCreatoreDetails"
          >
            <div class="postDetailsContainer">
              <figure class="pdp-host-info-avatar">
                <router-link
                  v-if="
                    post_datail &&
                    (post_datail.user_role == 'customer' ||
                      post_datail.user_role == 'consultant')
                  "
                  :to="`/profile-superior?uid=${post_datail?.user_id}`"
                >
                  <img
                    :src="post_datail?.user_avatar"
                    alt="customer_profil"
                    loading="lazy"
                    class="pdp-host-info-avatar__image"
                  />
                </router-link>
                <router-link
                  v-else-if="post_datail && post_datail.user_role == 'builder'"
                  :to="`/profile-builder?uid=${post_datail?.user_id}`"
                >
                  <img
                    :src="post_datail?.user_avatar"
                    alt="builder_avatar"
                    loading="lazy"
                    class="pdp-host-info-avatar__image"
                  />
                </router-link>
                <router-link
                  v-else
                  :to="`/profile-amlak?bid=${post_datail?.branch_id}`"
                >
                  <img
                    :src="post_datail?.branch_avatar"
                    alt="تصویر املاک"
                    loading="lazy"
                    class="pdp-host-info-avatar__image"
                  />
                </router-link>
              </figure>
              <div class="pdp-host-info-content detailsWrapper">
                <div class="pdp-host-info-content__titleWrapper">
                  <router-link
                    v-if="
                      post_datail &&
                      (post_datail.user_role == 'customer' ||
                        post_datail.user_role == 'consultant')
                    "
                    :to="`/profile-superior?uid=${post_datail?.user_id}`"
                  >
                    <h2 class="pdp-host-info-content__title">
                      {{ post_datail?.nickname }}
                      <span
                        v-if="
                          post_datail && post_datail.user_role == 'consultant'
                        "
                      >
                        <span style="margin: 0 2px">•</span> مباشر</span
                      >
                    </h2>
                  </router-link>
                  <router-link
                    v-else-if="
                      post_datail && post_datail.user_role == 'builder'
                    "
                    :to="`/profile-builder?uid=${post_datail?.user_id}`"
                  >
                    <h2 class="pdp-host-info-content__title">
                      {{ post_datail?.nickname }}
                    </h2>
                  </router-link>
                  <router-link
                    v-else
                    :to="`/profile-amlak?bid=${post_datail?.branch_id}`"
                  >
                    <h2
                      v-if="
                        post_datail &&
                        post_datail.branch_title &&
                        post_datail.branch_title != '-'
                      "
                      class="pdp-host-info-content__title"
                    >
                      {{ post_datail?.branch_title }}
                    </h2>
                  </router-link>
                  <div class="followersNum">
                    {{
                      post_datail && post_datail.branch_followers
                        ? post_datail.branch_followers
                        : 0
                    }}
                    دنبال کننده
                  </div>
                </div>

                <div
                  v-show="!$store.state.auth.loggedIn"
                  @click="showLoginBox"
                  class="ShowClickFollow"
                  :class="[
                    post_datail && post_datail.is_follow == 1
                      ? 'follow'
                      : 'unfollow',
                  ]"
                >
                  <span> دنبال کردن </span>
                </div>
                <div
                  v-show="
                    $store.state.auth.loggedIn &&
                    !loadingFollow &&
                    authDetails &&
                    post_datail &&
                    authDetails.uid != post_datail.user_id
                  "
                  @click="follow(post_datail?.branch_admin)"
                  class="ShowClickFollow"
                  :class="[
                    post_datail && post_datail.is_follow == 1
                      ? 'follow'
                      : 'unfollow',
                  ]"
                >
                  <span v-if="post_datail && post_datail.is_follow == 1">
                    دنبال کردن
                  </span>
                  <span v-if="post_datail && post_datail.is_follow == 2"
                    >لغو دنبال کردن
                  </span>
                </div>

                <div
                  v-show="loadingFollow"
                  class="ShowClickFollow"
                  :class="[
                    post_datail && post_datail.is_follow == 1
                      ? 'follow'
                      : 'unfollow',
                  ]"
                >
                  <div class="loader"></div>
                </div>
              </div>
            </div>
            <div
              v-if="post_datail && post_datail.user_role == 'consultant'"
              class="postBranchDetails"
            >
              <router-link
                :to="`/profile-amlak?bid=${post_datail?.branch_id}`"
                class="detailsThumb"
              >
                <div class="thumbPic">
                  <img :src="post_datail?.branch_avatar" alt="" />
                </div>
                <div class="thumbContent">
                  {{ post_datail?.branch_title }}
                  <span style="margin: 0 2px">•</span> مدیریت
                  {{ post_datail?.branch_admin_name }}
                </div>
              </router-link>
            </div>
          </section>
          <LoginUser @close="ShowLoginBoxes = false" v-if="ShowLoginBoxes" />
          <section class="accommodation-pdp-specifications">
            <header class="accommodation-pdp-specifications-heading">
              <h2 class="accommodation-pdp-specifications-heading__title">
                مشخصات
              </h2>
            </header>
            <div class="accommodation-pdp-specifications__container">
              <div
                class="accommodation-pdp-specification specificationIcon specificationFlex"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M8.25 21v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21m0 0h4.5V3.545M12.75 21h7.5V10.75M2.25 21h1.5m18 0h-18M2.25 9l4.5-1.636M18.75 3l-1.5.545m0 6.205 3 1m1.5.5-1.5-.5M6.75 7.364V3h-3v18m3-13.636 10.5-3.819"
                  />
                </svg>
                <div class="accommodation-pdp-specification-content">
                  <span class="accommodation-pdp-specification-content__title">
                    درباره ملک:
                  </span>
                  <div class="accommodation-pdp-specification-description">
                    <span
                      v-if="
                        post_datail &&
                        post_datail.main_category_en != 'request' &&
                        post_datail.category_en != 'garden' &&
                        post_datail.category_en != 'land'
                      "
                      class="accommodation-pdp-specification-description__item"
                      >{{ post_datail?.building_area }}
                      <span
                        v-if="
                          post_datail &&
                          (post_datail.category_en === 'apartment' ||
                            post_datail.category_en === 'Administrative' ||
                            post_datail.category_en === 'industrial' ||
                            post_datail.category_en === 'commercial')
                        "
                        style="margin-right: 3px"
                      >
                        متر
                      </span>
                      <span v-else style="margin-right: 3px"> متر بنا</span>
                    </span>
                    <span
                      v-if="
                        post_datail &&
                        post_datail.main_category_en == 'request' &&
                        post_datail.category_en != 'garden' &&
                        post_datail.category_en != 'land'
                      "
                      class="accommodation-pdp-specification-description__item"
                      >{{ post_datail?.building_area }} تا
                      {{ post_datail?.building_area_max }}
                      <span
                        v-if="
                          post_datail &&
                          (post_datail.category_en === 'apartment' ||
                            post_datail.category_en === 'Administrative' ||
                            post_datail.category_en === 'industrial' ||
                            post_datail.category_en === 'commercial')
                        "
                        style="margin-right: 3px"
                      >
                        متر
                      </span>
                      <span v-else style="margin-right: 3px"> متر بنا</span>
                    </span>
                    <span
                      v-if="
                        post_datail &&
                        post_datail.main_category_en != 'request' &&
                        (post_datail.category_en === 'villa_house' ||
                          post_datail.category_en === 'garden' ||
                          post_datail.category_en === 'land')
                      "
                      class="accommodation-pdp-specification-description__item"
                      >{{ post_datail?.land_area }} متر زمین
                    </span>
                    <span
                      v-if="
                        post_datail &&
                        post_datail.main_category_en == 'request' &&
                        (post_datail.category_en === 'villa_house' ||
                          post_datail.category_en === 'garden' ||
                          post_datail.category_en === 'land')
                      "
                      class="accommodation-pdp-specification-description__item"
                      >{{ post_datail?.land_area }} تا
                      {{ post_datail?.land_area_max }} متر زمین
                    </span>

                    <span
                      v-if="
                        post_datail &&
                        post_datail.main_category_en !== 'request' &&
                        post_datail.category_en !== 'villa_house' &&
                        post_datail.category_en !== 'commercial' &&
                        post_datail.category_en !== 'industrial' &&
                        post_datail.category_en !== 'land' &&
                        post_datail.category_en !== 'garden'
                      "
                      class="accommodation-pdp-specification-description__item"
                    >
                      <span v-if="post_datail && post_datail.floor != 0">
                        طبقه {{ post_datail?.floor }}
                      </span>
                      <span v-if="post_datail && post_datail.floor == 0">
                        همکف
                      </span>
                    </span>
                    <!---->
                  </div>
                </div>
              </div>
              <div
                class="accommodation-pdp-specification specificationIcon specificationFlex"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z"
                  />
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 6h.008v.008H6V6Z"
                  />
                </svg>
                <div class="accommodation-pdp-specification-content">
                  <span class="accommodation-pdp-specification-content__title">
                    دسته بندی:
                  </span>
                  <div class="accommodation-pdp-specification-description">
                    <span
                      class="accommodation-pdp-specification-description__item"
                    >
                      {{ post_datail?.main_category }}
                      <span
                        v-if="
                          post_datail &&
                          post_datail.main_category_en == 'request'
                        "
                        >{{ post_datail.request_type }}</span
                      >
                    </span>
                    <span
                      class="accommodation-pdp-specification-description__item"
                    >
                      {{ post_datail?.category }}
                    </span>
                    <!---->
                  </div>
                </div>
              </div>
              <div
                class="accommodation-pdp-specification specificationIcon specificationFlex"
                v-if="
                  post_datail &&
                  post_datail.category_en != 'commercial' &&
                  post_datail.category_en != 'industrial' &&
                  post_datail.category_en != 'garden' &&
                  post_datail.category_en != 'land' &&
                  post_datail.bedroom != null
                "
              >
                <svg
                  class="specification"
                  fill="#000000"
                  viewBox="0 0 50 50"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <path
                    d="M5 10C3.355469 10 2 11.355469 2 13L2 28.1875C2.003906 28.25 2.015625 28.3125 2.03125 28.375C2.03125 28.386719 2.03125 28.394531 2.03125 28.40625C1.582031 29.113281 1.214844 29.867188 0.9375 30.6875C0.316406 32.519531 0.0507813 34.621094 0 37L0 38C0 38.03125 0 38.0625 0 38.09375L0 50L7 50L7 46C7 45.167969 7.203125 44.734375 7.46875 44.46875C7.734375 44.203125 8.167969 44 9 44L41 44C41.832031 44 42.265625 44.203125 42.53125 44.46875C42.796875 44.734375 43 45.167969 43 46L43 50L50 50L50 38.15625C50.003906 38.105469 50.003906 38.050781 50 38C50 37.65625 50.007813 37.332031 50 37C49.949219 34.621094 49.683594 32.519531 49.0625 30.6875C48.785156 29.875 48.414063 29.136719 47.96875 28.4375C47.988281 28.355469 48 28.273438 48 28.1875L48 13C48 11.355469 46.644531 10 45 10 Z M 5 12L45 12C45.5625 12 46 12.4375 46 13L46 26.15625C45.753906 25.949219 45.492188 25.75 45.21875 25.5625C44.550781 25.101563 43.824219 24.671875 43 24.3125L43 20C43 19.296875 42.539063 18.75 42.03125 18.40625C41.523438 18.0625 40.902344 17.824219 40.125 17.625C38.570313 17.226563 36.386719 17 33.5 17C30.613281 17 28.429688 17.226563 26.875 17.625C26.117188 17.820313 25.5 18.042969 25 18.375C24.5 18.042969 23.882813 17.820313 23.125 17.625C21.570313 17.226563 19.386719 17 16.5 17C13.613281 17 11.429688 17.226563 9.875 17.625C9.097656 17.824219 8.476563 18.0625 7.96875 18.40625C7.460938 18.75 7 19.296875 7 20L7 24.3125C6.175781 24.671875 5.449219 25.101563 4.78125 25.5625C4.507813 25.75 4.246094 25.949219 4 26.15625L4 13C4 12.4375 4.4375 12 5 12 Z M 16.5 19C19.28125 19 21.34375 19.234375 22.625 19.5625C23.265625 19.726563 23.707031 19.925781 23.90625 20.0625C23.988281 20.117188 23.992188 20.125 24 20.125L24 22C17.425781 22.042969 12.558594 22.535156 9 23.625L9 20.125C9.007813 20.125 9.011719 20.117188 9.09375 20.0625C9.292969 19.925781 9.734375 19.726563 10.375 19.5625C11.65625 19.234375 13.71875 19 16.5 19 Z M 33.5 19C36.28125 19 38.34375 19.234375 39.625 19.5625C40.265625 19.726563 40.707031 19.925781 40.90625 20.0625C40.988281 20.117188 40.992188 20.125 41 20.125L41 23.625C37.441406 22.535156 32.574219 22.042969 26 22L26 20.125C26.007813 20.125 26.011719 20.117188 26.09375 20.0625C26.292969 19.925781 26.734375 19.726563 27.375 19.5625C28.65625 19.234375 30.71875 19 33.5 19 Z M 24.8125 24C24.917969 24.015625 25.019531 24.015625 25.125 24C25.15625 24 25.1875 24 25.21875 24C35.226563 24.015625 41.007813 25.0625 44.09375 27.1875C45.648438 28.257813 46.589844 29.585938 47.1875 31.34375C47.707031 32.875 47.917969 34.761719 47.96875 37L2.03125 37C2.082031 34.761719 2.292969 32.875 2.8125 31.34375C3.410156 29.585938 4.351563 28.257813 5.90625 27.1875C8.992188 25.058594 14.785156 24.011719 24.8125 24 Z M 2 39L48 39L48 48L45 48L45 46C45 44.832031 44.703125 43.765625 43.96875 43.03125C43.234375 42.296875 42.167969 42 41 42L9 42C7.832031 42 6.765625 42.296875 6.03125 43.03125C5.296875 43.765625 5 44.832031 5 46L5 48L2 48Z"
                  />
                </svg>
                <div class="accommodation-pdp-specification-content">
                  <span class="accommodation-pdp-specification-content__title">
                    سرویس‌های خواب:
                  </span>
                  <div class="accommodation-pdp-specification-description">
                    <span
                      v-if="post_datail && post_datail.bedroom == 0"
                      class="accommodation-pdp-specification-description__item"
                      >بدون خواب</span
                    >
                    <span
                      v-else
                      class="accommodation-pdp-specification-description__item"
                      >{{ post_datail?.bedroom }} خواب</span
                    >
                    <!---->
                  </div>
                </div>
              </div>
              <div
                class="accommodation-pdp-specification specificationFlex"
                v-if="
                  post_datail &&
                  post_datail.category_en != 'garden' &&
                  post_datail.category_en != 'land' &&
                  post_datail.completion_date != null
                "
              >
                <figure class="accommodation-pdp-specification-icon">
                  <VsxIcon
                    iconName="Calendar"
                    :size="26"
                    color="#000"
                    type="linear"
                  />
                </figure>
                <div class="accommodation-pdp-specification-content">
                  <span class="accommodation-pdp-specification-content__title">
                    سال ساخت:
                  </span>
                  <div class="accommodation-pdp-specification-description">
                    <span
                      class="accommodation-pdp-specification-description__item"
                    >
                      <div
                        v-if="
                          post_datail &&
                          post_datail.main_category_en != 'request'
                        "
                      >
                        {{ post_datail?.completion_date }}
                      </div>
                      <div
                        v-if="
                          post_datail &&
                          post_datail.main_category_en == 'request'
                        "
                      >
                        {{ post_datail?.completion_date }} -
                        {{ post_datail?.completion_date_max }}
                      </div>
                    </span>
                    <!---->
                  </div>
                </div>
              </div>
              <div
                v-if="post_datail && post_datail.main_category_en != 'rent'"
                class="accommodation-pdp-specification specificationFlex"
              >
                <figure class="accommodation-pdp-specification-icon">
                  <VsxIcon
                    iconName="DocumentText"
                    :size="26"
                    color="#000"
                    type="linear"
                  />
                </figure>
                <div class="accommodation-pdp-specification-content">
                  <span class="accommodation-pdp-specification-content__title">
                    نوع سند:
                  </span>
                  <div class="accommodation-pdp-specification-description">
                    <span
                      class="accommodation-pdp-specification-description__item"
                      >{{ post_datail?.doc_type }}</span
                    >
                    <!---->
                  </div>
                </div>
              </div>
              <div
                v-if="
                  post_datail &&
                  (post_datail.category_en == 'villa_house' ||
                    post_datail.category_en == 'garden' ||
                    post_datail.category_en == 'land') &&
                  post_datail.passage_width != null
                "
                class="accommodation-pdp-specification specificationFlex"
              >
                <figure class="accommodation-pdp-specification-icon">
                  <svg
                    class="roadWidth"
                    version="1.1"
                    id="_x32_"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 512 512"
                    xml:space="preserve"
                  >
                    <g>
                      <polygon
                        class="st0"
                        points="412.061,152.986 373.039,152.986 447.993,359.014 512,359.014  "
                      />
                      <polygon
                        class="st0"
                        points="99.939,152.986 0,359.014 64.006,359.014 138.961,152.986  "
                      />
                      <path
                        class="st0"
                        d="M265.767,152.986l0.367,12.226H245.86l0.373-12.226h-77.996l-56.201,206.027h127.943l0.911-29.861h30.222   l0.906,29.861h128.019l-56.231-206.027H265.767z M245.15,188.742h21.7l0.823,27.121h-23.346L245.15,188.742z M242.238,284.627   l1.13-37.223h25.263l1.13,37.223H242.238z"
                      />
                    </g>
                  </svg>
                </figure>
                <div class="accommodation-pdp-specification-content">
                  <span class="accommodation-pdp-specification-content__title">
                    عرض کوچه:
                  </span>
                  <div
                    v-if="post_datail && post_datail.passage_width"
                    class="accommodation-pdp-specification-description"
                  >
                    <span
                      class="accommodation-pdp-specification-description__item"
                      >{{ post_datail?.passage_width }}</span
                    >
                    متر
                    <!---->
                  </div>
                  <div
                    v-else
                    class="accommodation-pdp-specification-description"
                  >
                    <span
                      class="accommodation-pdp-specification-description__item"
                      >-</span
                    >
                    <!---->
                  </div>
                </div>
              </div>
              <div
                v-if="
                  post_datail &&
                  (post_datail.category_en == 'villa_house' ||
                    post_datail.category_en == 'garden' ||
                    post_datail.category_en == 'land') &&
                  post_datail.width &&
                  post_datail.width != 0
                "
                class="accommodation-pdp-specification specificationFlex"
              >
                <figure class="accommodation-pdp-specification-icon">
                  <svg
                    class="specification"
                    viewBox="0 0 16 16"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="m15.46 7-4-2.74-.71 1 3.09 2.11H2.16l3.09-2.1-.71-1L.54 7a1.25 1.25 0 0 0 0 2l4 2.74.71-1-3.09-2.12h11.68l-3.09 2.11.71 1 4-2.74a1.25 1.25 0 0 0 0-1.99z"
                    />
                  </svg>
                </figure>
                <div class="accommodation-pdp-specification-content">
                  <span class="accommodation-pdp-specification-content__title">
                    عرض زمین:
                  </span>
                  <div
                    v-if="post_datail && post_datail.width"
                    class="accommodation-pdp-specification-description"
                  >
                    <span
                      class="accommodation-pdp-specification-description__item"
                      >{{ post_datail?.width }}</span
                    >
                    متر
                    <!---->
                  </div>
                  <div
                    v-else
                    class="accommodation-pdp-specification-description"
                  >
                    <span
                      class="accommodation-pdp-specification-description__item"
                      >-</span
                    >
                    <!---->
                  </div>
                </div>
              </div>
              <div
                v-if="
                  post_datail &&
                  post_datail.category_en != 'villa_house' &&
                  post_datail.category_en != 'commercial' &&
                  post_datail.category_en != 'industrial' &&
                  post_datail.category_en != 'land' &&
                  post_datail.category_en != 'garden' &&
                  post_datail.elevator != null
                "
                class="accommodation-pdp-specification specificationFlex"
              >
                <figure class="accommodation-pdp-specification-icon">
                  <svg
                    class="elevator"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 22h15V2H2zm14-1h-6V3h6zM3 3h6v18H3zm15.625 10h3.75L20.5 16zm3.75-2h-3.75L20.5 8z"
                    />
                    <path fill="none" d="M0 0h24v24H0z" />
                  </svg>
                </figure>
                <div class="accommodation-pdp-specification-content">
                  <span class="accommodation-pdp-specification-content__title">
                    آسانسور:
                  </span>
                  <div class="accommodation-pdp-specification-description">
                    <span
                      v-if="post_datail && post_datail.elevator == 'دارد'"
                      class="accommodation-pdp-specification-description__item"
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 21L17 28L30 13"
                          stroke="currentColor"
                          stroke-width="4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    <span
                      v-if="post_datail && post_datail.elevator == 'ندارد'"
                      class="accommodation-pdp-specification-description__item"
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 12L28 28M28 12L12 28"
                          stroke="currentColor"
                          stroke-width="4"
                          stroke-linecap="round"
                        />
                      </svg>
                    </span>
                    <!---->
                  </div>
                </div>
              </div>
              <div
                v-if="
                  post_datail &&
                  post_datail.category_en !== 'villa' &&
                  post_datail.category_en !== 'commercial' &&
                  post_datail.category_en !== 'industrial' &&
                  post_datail.category_en !== 'land' &&
                  post_datail.category_en !== 'garden' &&
                  post_datail.main_category_en != 'request' &&
                  post_datail.storage != null
                "
                class="accommodation-pdp-specification specificationFlex"
              >
                <figure class="accommodation-pdp-specification-icon">
                  <VsxIcon
                    iconName="Box1"
                    :size="26"
                    color="#000"
                    type="linear"
                  />
                </figure>
                <div
                  v-if="post_datail.main_category_en != 'request'"
                  class="accommodation-pdp-specification-content"
                >
                  <span class="accommodation-pdp-specification-content__title">
                    انباری:
                  </span>
                  <div class="accommodation-pdp-specification-description">
                    <span
                      v-if="post_datail && post_datail.storage == 'دارد'"
                      class="accommodation-pdp-specification-description__item"
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 21L17 28L30 13"
                          stroke="currentColor"
                          stroke-width="4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    <span
                      v-if="post_datail && post_datail.storage == 'ندارد'"
                      class="accommodation-pdp-specification-description__item"
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 12L28 28M28 12L12 28"
                          stroke="currentColor"
                          stroke-width="4"
                          stroke-linecap="round"
                        />
                      </svg>
                    </span>
                    <!---->
                  </div>
                </div>
              </div>
              <div
                class="accommodation-pdp-specification specificationFlex"
                v-if="
                  post_datail &&
                  post_datail.category_en != 'commercial' &&
                  post_datail.category_en != 'industrial' &&
                  post_datail.category_en != 'garden' &&
                  post_datail.category_en != 'land' &&
                  post_datail.parking != null
                "
              >
                <figure class="accommodation-pdp-specification-icon">
                  <svg
                    class="elevator"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5,22H19a3,3,0,0,0,3-3V5a3,3,0,0,0-3-3H5A3,3,0,0,0,2,5V19A3,3,0,0,0,5,22ZM4,5A1,1,0,0,1,5,4H19a1,1,0,0,1,1,1V19a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1ZM9,18a1,1,0,0,0,1-1V14h2a4,4,0,0,0,0-8H9A1,1,0,0,0,8,7V17A1,1,0,0,0,9,18ZM10,8h2a2,2,0,0,1,0,4H10Z"
                    />
                  </svg>
                </figure>
                <div class="accommodation-pdp-specification-content">
                  <span class="accommodation-pdp-specification-content__title">
                    پارکینگ:
                  </span>
                  <div class="accommodation-pdp-specification-description">
                    <span
                      v-if="post_datail && post_datail.parking == 'دارد'"
                      class="accommodation-pdp-specification-description__item"
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 21L17 28L30 13"
                          stroke="currentColor"
                          stroke-width="4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    <span
                      v-if="post_datail && post_datail.parking == 'ندارد'"
                      class="accommodation-pdp-specification-description__item"
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 12L28 28M28 12L12 28"
                          stroke="currentColor"
                          stroke-width="4"
                          stroke-linecap="round"
                        />
                      </svg>
                    </span>
                    <!---->
                  </div>
                </div>
              </div>
              <div
                class="accommodation-pdp-specification specificationFlex"
                v-if="
                  post_datail &&
                  post_datail.category_en == 'villa' &&
                  post_datail.main_category_en != 'rent' &&
                  post_datail.request_type_en != 'rent'
                "
              >
                <figure class="accommodation-pdp-specification-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 0 1 9 9v.375M10.125 2.25A3.375 3.375 0 0 1 13.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 0 1 3.375 3.375M9 15l2.25 2.25L15 12"
                    />
                  </svg>
                </figure>
                <div class="accommodation-pdp-specification-content">
                  <span class="accommodation-pdp-specification-content__title">
                    پروانه ساخت:
                  </span>
                  <div class="accommodation-pdp-specification-description">
                    <span
                      v-if="post_datail && post_datail.building_license_date"
                      class="accommodation-pdp-specification-description__item"
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 21L17 28L30 13"
                          stroke="currentColor"
                          stroke-width="4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    <span
                      v-else
                      class="accommodation-pdp-specification-description__item"
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 12L28 28M28 12L12 28"
                          stroke="currentColor"
                          stroke-width="4"
                          stroke-linecap="round"
                        />
                      </svg>
                    </span>
                    <!---->
                  </div>
                </div>
              </div>
              <div
                class="accommodation-pdp-specification specificationFlex"
                v-if="
                  post_datail &&
                  post_datail.category_en == 'villa' &&
                  post_datail.main_category_en != 'rent' &&
                  post_datail.request_type_en != 'rent'
                "
              >
                <figure class="accommodation-pdp-specification-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z"
                    />
                  </svg>
                </figure>
                <div class="accommodation-pdp-specification-content">
                  <span class="accommodation-pdp-specification-content__title">
                    پایان کار:
                  </span>
                  <div class="accommodation-pdp-specification-description">
                    <span
                      v-if="
                        post_datail &&
                        post_datail.feature &&
                        post_datail.feature.includes('workend')
                      "
                      class="accommodation-pdp-specification-description__item"
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 21L17 28L30 13"
                          stroke="currentColor"
                          stroke-width="4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    <span
                      v-else
                      class="accommodation-pdp-specification-description__item"
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 12L28 28M28 12L12 28"
                          stroke="currentColor"
                          stroke-width="4"
                          stroke-linecap="round"
                        />
                      </svg>
                    </span>
                    <!---->
                  </div>
                </div>
              </div>
              <div
                class="accommodation-pdp-specification specificationFlex"
                v-if="
                  post_datail &&
                  post_datail.category_en != 'villa_house' &&
                  post_datail.category_en != 'commercial' &&
                  post_datail.category_en != 'industrial' &&
                  post_datail.category_en != 'land' &&
                  post_datail.category_en != 'garden' &&
                  post_datail.total_floor != null
                "
              >
                <figure class="accommodation-pdp-specification-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"
                    />
                  </svg>
                </figure>
                <div class="accommodation-pdp-specification-content">
                  <span class="accommodation-pdp-specification-content__title">
                    تعداد طبقات:
                  </span>
                  <div class="accommodation-pdp-specification-description">
                    <span
                      class="accommodation-pdp-specification-description__item"
                      >{{ post_datail?.total_floor }}</span
                    >
                    <!---->
                  </div>
                </div>
              </div>
              <div
                class="accommodation-pdp-specification specificationFlex"
                v-if="
                  post_datail &&
                  (post_datail.category_en == 'apartment' ||
                    post_datail.category_en == 'Administrative') &&
                  post_datail.floor_units != null
                "
              >
                <figure class="accommodation-pdp-specification-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z"
                    />
                  </svg>
                </figure>
                <div class="accommodation-pdp-specification-content">
                  <span class="accommodation-pdp-specification-content__title">
                    تعداد واحد:
                  </span>
                  <div class="accommodation-pdp-specification-description">
                    <span
                      class="accommodation-pdp-specification-description__item"
                      >{{ post_datail?.floor_units }}</span
                    >
                    <!---->
                  </div>
                </div>
              </div>
              <div
                class="accommodation-pdp-specification specificationFlex"
                v-if="
                  post_datail &&
                  post_datail.main_category_en == 'request' &&
                  post_datail.districts &&
                  post_datail.districts.length > 0
                "
              >
                <figure
                  class="accommodation-pdp-specification-icon districtsIcon"
                >
                  <svg
                    fill="#000000"
                    width="800px"
                    height="800px"
                    viewBox="0 0 56 56"
                    xmlns="http://www.w3.org/2000/svg"
                    class="distrcitsSvg"
                  >
                    <path
                      d="M 27.9883 43.1992 C 28.9492 43.1992 30.1680 39.4492 30.1680 32.5352 L 30.1680 21.4961 C 33.9883 20.5117 36.8008 17.0430 36.8008 12.9180 C 36.8008 8.0664 32.8867 4.1055 27.9883 4.1055 C 23.1133 4.1055 19.1992 8.0664 19.1992 12.9180 C 19.1992 17.0430 21.9883 20.5117 25.8086 21.4726 L 25.8086 32.5352 C 25.8086 39.4258 27.0508 43.1992 27.9883 43.1992 Z M 25.4805 13.4102 C 23.8867 13.4102 22.4805 12.0039 22.4805 10.3867 C 22.4805 8.7461 23.8867 7.3633 25.4805 7.3633 C 27.1211 7.3633 28.4805 8.7461 28.4805 10.3867 C 28.4805 12.0039 27.1211 13.4102 25.4805 13.4102 Z M 27.9883 51.8945 C 42.1680 51.8945 50.3711 46.9727 50.3711 41.7461 C 50.3711 35.4414 40.3399 31.6211 33.8711 31.5977 L 33.8711 35.2539 C 38.3711 35.2774 45.3789 37.7148 45.3789 41.1836 C 45.3789 44.8633 38.7696 47.9570 27.9883 47.9570 C 17.2305 47.9570 10.6211 44.8867 10.6211 41.1836 C 10.6211 37.7148 17.6289 35.2774 22.1289 35.2539 L 22.1289 31.5977 C 15.6602 31.6211 5.6289 35.4414 5.6289 41.7461 C 5.6289 46.9727 13.8321 51.8945 27.9883 51.8945 Z"
                    />
                  </svg>
                </figure>
                <div class="accommodation-pdp-specification-content">
                  <span class="accommodation-pdp-specification-content__title">
                    مناطق انتخابی:
                  </span>
                  <div
                    v-if="post_datail"
                    class="accommodation-pdp-specification-description selectedLocations"
                  >
                    <span
                      v-for="(v, i) in post_datail.districts"
                      :key="i"
                      class="accommodation-pdp-specification-description__item districtsThumb"
                      >{{ v }}</span
                    >
                    <!---->
                  </div>
                </div>
              </div>
              <div
                class="accommodation-pdp-specification specificationFlex"
                v-if="
                  post_datail &&
                  post_datail.feature &&
                  post_datail.feature.includes('fast')
                "
              >
                <figure class="accommodation-pdp-specification-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    class="size-6"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M14.615 1.595a.75.75 0 0 1 .359.852L12.982 9.75h7.268a.75.75 0 0 1 .548 1.262l-10.5 11.25a.75.75 0 0 1-1.272-.71l1.992-7.302H3.75a.75.75 0 0 1-.548-1.262l10.5-11.25a.75.75 0 0 1 .913-.143Z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </figure>
                <div
                  class="accommodation-pdp-specification-content featuresRow"
                >
                  <span class="accommodation-pdp-specification-content__title">
                    این آگهی فوری می‌باشد.
                  </span>
                </div>
              </div>
              <div
                class="accommodation-pdp-specification specificationFlex"
                v-if="
                  post_datail &&
                  post_datail.feature &&
                  post_datail.main_category_en == 'rent' &&
                  (post_datail.feature.includes('single') ||
                    post_datail.feature.includes('student'))
                "
              >
                <figure class="accommodation-pdp-specification-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
                    />
                  </svg>
                </figure>
                <div
                  class="accommodation-pdp-specification-content featuresRow"
                >
                  <span class="accommodation-pdp-specification-content__title">
                    به افراد
                    <span
                      v-if="
                        post_datail &&
                        post_datail.feature &&
                        post_datail.feature.includes('single')
                      "
                      >مجرد</span
                    >
                    <span
                      v-if="
                        post_datail &&
                        post_datail.feature &&
                        post_datail.feature.includes('single') &&
                        post_datail.feature.includes('student')
                      "
                    >
                      و
                    </span>
                    <span
                      v-if="
                        post_datail &&
                        post_datail.feature &&
                        post_datail.feature.includes('student')
                      "
                      >دانشجو</span
                    >
                    اجاره داده می‌شود
                  </span>
                </div>
              </div>
              <div
                class="accommodation-pdp-specification specificationFlex"
                v-if="
                  post_datail &&
                  post_datail.feature &&
                  post_datail.main_category_en == 'rent' &&
                  post_datail.feature.includes('furnished')
                "
              >
                <figure class="accommodation-pdp-specification-icon">
                  <svg
                    viewBox="0 0 512 512"
                    enable-background="new 0 0 512 512"
                    id="Layer_1"
                    version="1.1"
                    xml:space="preserve"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g>
                      <g>
                        <path
                          d="M171.534,187.347h-0.362c-5.523,0-10-4.477-10-10s4.477-10,10-10h0.362c5.523,0,10,4.477,10,10    S177.057,187.347,171.534,187.347z"
                        />
                      </g>

                      <g>
                        <path
                          d="M171.354,226.22h-0.363c-5.523,0-10-4.477-10-10s4.477-10,10-10h0.363c5.523,0,10,4.477,10,10    S176.876,226.22,171.354,226.22z"
                        />
                      </g>

                      <g>
                        <path
                          d="M256.272,187.347h-0.363c-5.523,0-10-4.477-10-10s4.477-10,10-10h0.363c5.522,0,10,4.477,10,10    S261.795,187.347,256.272,187.347z"
                        />
                      </g>

                      <g>
                        <path
                          d="M256.091,226.22h-0.363c-5.523,0-10-4.477-10-10s4.477-10,10-10h0.363c5.522,0,10,4.477,10,10    S261.613,226.22,256.091,226.22z"
                        />
                      </g>

                      <g>
                        <path
                          d="M343.462,187.347h-0.364c-5.522,0-10-4.477-10-10s4.478-10,10-10h0.364c5.522,0,10,4.477,10,10    S348.984,187.347,343.462,187.347z"
                        />
                      </g>

                      <g>
                        <path
                          d="M343.279,226.22h-0.362c-5.522,0-10-4.477-10-10s4.478-10,10-10h0.362c5.522,0,10,4.477,10,10    S348.802,226.22,343.279,226.22z"
                        />
                      </g>

                      <g>
                        <path
                          d="M385.695,297.062H126.305c-5.523,0-10-4.477-10-10v-66.482c0-1.698-1.381-3.079-3.079-3.079H95.243    c-5.523,0-10-4.477-10-10v-49.044c0-12.726,10.353-23.079,23.078-23.079h295.357c12.726,0,23.078,10.353,23.078,23.079V207.5    c0,5.523-4.478,10-10,10h-17.982c-1.698,0-3.079,1.381-3.079,3.079v66.482C395.695,292.584,391.218,297.062,385.695,297.062z     M136.305,277.062h239.391v-56.482c0-12.726,10.354-23.079,23.079-23.079h7.982v-39.044c0-1.698-1.381-3.079-3.078-3.079H108.321    c-1.697,0-3.078,1.381-3.078,3.079V197.5h7.982c12.726,0,23.079,10.353,23.079,23.079V277.062z"
                        />
                      </g>

                      <g>
                        <path
                          d="M434.74,376.623H77.26c-12.725,0-23.078-10.353-23.078-23.079V220.579c0-12.726,10.353-23.079,23.078-23.079h35.966    c12.726,0,23.079,10.353,23.079,23.079v56.482h239.391v-56.482c0-12.726,10.354-23.079,23.079-23.079h35.966    c12.726,0,23.078,10.353,23.078,23.079v132.965C457.818,366.27,447.466,376.623,434.74,376.623z M77.26,217.5    c-1.697,0-3.078,1.381-3.078,3.079v132.965c0,1.697,1.381,3.079,3.078,3.079h357.48c1.697,0,3.078-1.381,3.078-3.079V220.579    c0-1.697-1.381-3.079-3.078-3.079h-35.966c-1.698,0-3.079,1.381-3.079,3.079v66.482c0,5.523-4.478,10-10,10H126.305    c-5.523,0-10-4.477-10-10v-66.482c0-1.697-1.381-3.079-3.079-3.079H77.26z"
                        />
                      </g>
                    </g>
                  </svg>
                </figure>
                <div
                  class="accommodation-pdp-specification-content featuresRow"
                >
                  <span class="accommodation-pdp-specification-content__title">
                    به صورت مبله اجاره داده میشود
                  </span>
                </div>
              </div>
              <div
                class="accommodation-pdp-specification specificationFlex"
                v-if="
                  post_datail &&
                  post_datail.feature &&
                  (post_datail.feature.includes('exchangeable') ||
                    post_datail.feature.includes('convertable'))
                "
              >
                <figure class="accommodation-pdp-specification-icon">
                  <svg
                    class="specification"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.96967 12.5303C8.26256 12.8232 8.73744 12.8232 9.03033 12.5303C9.32322 12.2374 9.32322 11.7626 9.03033 11.4697L7.96967 12.5303ZM5.53033 7.96967C5.23744 7.67678 4.76256 7.67678 4.46967 7.96967C4.17678 8.26256 4.17678 8.73744 4.46967 9.03033L5.53033 7.96967ZM5 7.75C4.58579 7.75 4.25 8.08579 4.25 8.5C4.25 8.91421 4.58579 9.25 5 9.25V7.75ZM19 9.25C19.4142 9.25 19.75 8.91421 19.75 8.5C19.75 8.08579 19.4142 7.75 19 7.75V9.25ZM4.46967 7.96967C4.17678 8.26256 4.17678 8.73744 4.46967 9.03033C4.76256 9.32322 5.23744 9.32322 5.53033 9.03033L4.46967 7.96967ZM9.03033 5.53033C9.32322 5.23744 9.32322 4.76256 9.03033 4.46967C8.73744 4.17678 8.26256 4.17678 7.96967 4.46967L9.03033 5.53033ZM16.0303 11.4697C15.7374 11.1768 15.2626 11.1768 14.9697 11.4697C14.6768 11.7626 14.6768 12.2374 14.9697 12.5303L16.0303 11.4697ZM18.4697 16.0303C18.7626 16.3232 19.2374 16.3232 19.5303 16.0303C19.8232 15.7374 19.8232 15.2626 19.5303 14.9697L18.4697 16.0303ZM19 16.25C19.4142 16.25 19.75 15.9142 19.75 15.5C19.75 15.0858 19.4142 14.75 19 14.75V16.25ZM5 14.75C4.58579 14.75 4.25 15.0858 4.25 15.5C4.25 15.9142 4.58579 16.25 5 16.25V14.75ZM19.5303 16.0303C19.8232 15.7374 19.8232 15.2626 19.5303 14.9697C19.2374 14.6768 18.7626 14.6768 18.4697 14.9697L19.5303 16.0303ZM14.9697 18.4697C14.6768 18.7626 14.6768 19.2374 14.9697 19.5303C15.2626 19.8232 15.7374 19.8232 16.0303 19.5303L14.9697 18.4697ZM9.03033 11.4697L5.53033 7.96967L4.46967 9.03033L7.96967 12.5303L9.03033 11.4697ZM5 9.25H19V7.75H5V9.25ZM5.53033 9.03033L9.03033 5.53033L7.96967 4.46967L4.46967 7.96967L5.53033 9.03033ZM14.9697 12.5303L18.4697 16.0303L19.5303 14.9697L16.0303 11.4697L14.9697 12.5303ZM19 14.75H5V16.25H19V14.75ZM18.4697 14.9697L14.9697 18.4697L16.0303 19.5303L19.5303 16.0303L18.4697 14.9697Z"
                      fill="#000000"
                    />
                  </svg>
                </figure>
                <div
                  class="accommodation-pdp-specification-content featuresRow"
                >
                  <span class="accommodation-pdp-specification-content__title">
                    قابل
                    <span
                      v-if="
                        post_datail &&
                        post_datail.feature &&
                        post_datail.feature.includes('convertable')
                      "
                      >تبدیل</span
                    >
                    <span
                      v-if="
                        post_datail &&
                        post_datail.feature &&
                        post_datail.feature.includes('exchangeable')
                      "
                      >معاوضه</span
                    >
                    می‌باشد
                  </span>
                </div>
              </div>
              <div
                class="accommodation-pdp-specification specificationFlex"
                v-if="
                  post_datail &&
                  post_datail.category_en == 'villa_house' &&
                  post_datail.main_category_en == 'trade'
                "
              >
                <figure class="accommodation-pdp-specification-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                    />
                  </svg>
                </figure>
                <div
                  class="accommodation-pdp-specification-content featuresRow"
                >
                  <span
                    v-if="
                      post_datail &&
                      post_datail.feature &&
                      post_datail.feature.includes('liveable')
                    "
                    class="accommodation-pdp-specification-content__title"
                  >
                    قابل سکونت می‌باشد
                  </span>
                  <span
                    v-else
                    class="accommodation-pdp-specification-content__title"
                  >
                    قابل سکونت نمی‌باشد
                  </span>
                </div>
              </div>
              <div
                class="accommodation-pdp-specification specificationFlex"
                v-if="
                  post_datail &&
                  post_datail.feature &&
                  post_datail.feature.includes('pet')
                "
              >
                <figure class="accommodation-pdp-specification-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="7" cy="9" r="2" fill="currentColor" />
                    <circle cx="12" cy="6" r="2" fill="currentColor" />
                    <circle cx="17" cy="9" r="2" fill="currentColor" />
                    <circle cx="9.5" cy="14" r="2.5" fill="currentColor" />
                    <circle cx="14.5" cy="14" r="2.5" fill="currentColor" />
                    <path
                      d="M16.5 17.5L18.5 19.5L22 16"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </figure>
                <div
                  class="accommodation-pdp-specification-content featuresRow"
                >
                  <span class="accommodation-pdp-specification-content__title">
                    حیوان خانگی مجاز می‌باشد.
                  </span>
                </div>
              </div>
            </div>
            <div class="reportBtnWrapper">
              <router-link class="repostBtn" to="/contact-us">
                گزارش تخلف
              </router-link>
            </div>
          </section>
          <section
            class="accommodation-description"
            v-if="post_datail && post_datail.details"
          >
            <header class="accommodation-description-heading btnAreaHeader">
              <h2 class="accommodation-description-heading__title">
                توضیحات ملک
              </h2>

              <div @click="btnCopyText" class="CopyClassText">
                <p>کپی</p>
                <VsxIcon
                  iconName="DocumentCopy"
                  :size="18"
                  color="#0096c7"
                  type="linear"
                />
              </div>
            </header>
            <!---->
            <div class="accommodation-description-content">
              <div v-html="formattedDetails"></div>
            </div>
          </section>
          <section
            v-if="post_datail && post_datail.facilities != ''"
            class="product-amenities"
          >
            <header class="product-amenities-heading">
              <h2
                class="product-amenities-heading__title"
                style="display: flex; align-items: center; gap: 7px"
              >
                امکانات
              </h2>
            </header>
            <ul v-if="post_datail" class="product-amenities-list">
              <li
                v-for="(v, i) in post_datail.facilities"
                :key="i"
                class="product-amenities-list__item"
              >
                {{ v }}
              </li>
            </ul>
          </section>

          <section
            v-show="
              post_datail && post_datail.address && post_datail.address != '-'
            "
            class="product-amenities"
          >
            <header class="product-amenities-heading">
              <h2
                class="product-amenities-heading__title"
                style="display: flex; align-items: center; gap: 7px"
              >
                موقعیت ملک
              </h2>
            </header>
            <div class="mapboxContainer">
              <div class="postLocation">
                موقعیت ملک: <span>{{ post_datail?.address }}</span>
              </div>
              <div
                v-show="
                  post_datail &&
                  post_datail.lat &&
                  post_datail.lng
                "
                id="map"
                class="map"
              ></div>
            </div>
          </section>
          <section
            v-if="
              post_datail &&
              post_datail.places &&
              post_datail.places.length > 0 &&
              (post_datail.places[0].child.length > 0 ||
                post_datail.places[1].child.length > 0)
            "
            class="accommodation-landmarks"
          >
            <header class="accommodation-landmarks-heading">
              <h2 class="accommodation-landmarks-heading__title">
                مراکز نزدیک ملک
              </h2>
              <p class="accommodation-landmarks-heading__description">
                تمامی فواصل به صورت حدودی و در شرایط معمولی ترافیک می‌باشد.
              </p>
            </header>
            <div
              v-for="(v, i) in post_datail?.places"
              :key="i"
              class="accommodation-landmarks-item"
            >
              <h3
                v-if="v.child.length > 0"
                class="accommodation-landmarks-item__title"
              >
                {{ v.title }}
              </h3>
              <ul
                v-if="v.child.length > 0"
                class="accommodation-landmarks-item-list"
              >
                <li
                  v-for="(vv, ii) in v.child"
                  :key="ii"
                  class="accommodation-landmark"
                >
                  <span class="accommodation-landmark__name">
                    فاصله تا {{ vv.property_title }}:
                  </span>
                  <span class="accommodation-landmark__distance">
                    {{ vv.property_time }} دقیقه
                  </span>
                </li>
              </ul>
            </div>
          </section>
          <section class="desktopComments">
            <header>
              <div class="j-list-section-title">
                <div class="j-list-section-title__content">
                  <div class="j-list-section-title__title">
                    <h2 class="commentTitle">
                      {{ formatPrice(post_datail?.comments_count) }}
                      <span>نظر ثبت شده</span>
                    </h2>
                  </div>
                </div>
              </div>
            </header>

            <section>
              <div class="commentsList">
                <div class="commentInputWrapper newCommentInput">
                  <div
                    v-if="$store.getters.auth.loggedIn"
                    class="inputUserProfile"
                  ></div>

                  <div v-if="$store.getters.auth.loggedIn" class="commentInput">
                    <div class="addCommentInput" :class="{ focus: isFocus }">
                      <input
                        type="text"
                        v-model="newComment"
                        placeholder="نظر خود را وارد کنید"
                        @focus="inputFocusHandler"
                        @blur="inputFocusHandler"
                      />
                    </div>

                    <div class="commentInputBtns">
                      <!--                    <div class="cancleBtn">انصراف</div>-->
                      <div
                        v-if="!comment_btn_loading"
                        class="commentBtn"
                        :class="{ disabled: newComment === '' }"
                        @click="save_comment()"
                      >
                        ثبت نظر
                      </div>
                      <div
                        v-if="comment_btn_loading"
                        class="commentBtn"
                        :class="{ disabled: newComment === '' }"
                      >
                        <span class="loader"></span>
                        <span style="margin-right: 5px"> ثبت نظر</span>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="!$store.getters.auth.loggedIn"
                    class="commentInput"
                  >
                    <span class="loginMessage">
                      برای ثبت نظر وارد حساب کاربری شوید
                    </span>
                  </div>
                </div>
                <div class="commentsContainer">
                  <div
                    class="commentThumb"
                    v-for="(CommentUserLists, i) in CommentUserList"
                    :key="i"
                  >
                    <div class="commentProfile">
                      <img :src="CommentUserLists.avatar" />
                    </div>
                    <div class="commentContent">
                      <div class="commentHeader">
                        <h6 class="userName">{{ CommentUserLists.name }}</h6>
                        <div class="commentDate">
                          {{ CommentUserLists.date }}
                        </div>
                      </div>
                      <div class="commentText">
                        {{ CommentUserLists.description }}
                      </div>
                      <div class="commentBtns">
                        <div class="commentLikesBtn"></div>
                        <div
                          class="commentReplyBtn"
                          @click="replyCommentHandler(i)"
                        >
                          پاسخ دهید
                        </div>
                      </div>
                      <div
                        class="commentInputWrapper"
                        :class="{ show: replyComment === i }"
                      >
                        <div class="inputUserProfile"></div>
                        <div class="commentInput">
                          <div
                            class="addCommentInput"
                            :class="{ focus: isFocus }"
                          >
                            <input
                              type="text"
                              v-model="comment_replay[CommentUserLists.id]"
                              placeholder="نظر خود را وارد کنید"
                              @focus="inputFocusHandler"
                              @blur="inputFocusHandler"
                            />
                          </div>

                          <div class="commentInputBtns">
                            <div
                              class="cancleBtn"
                              @click="replyCommentCloseHandler"
                            >
                              انصراف
                            </div>
                            <div
                              v-if="
                                !comment_btn_replay_loading[CommentUserLists.id]
                              "
                              class="commentBtn"
                              :class="{
                                disabled:
                                  comment_replay[CommentUserLists.id] === '',
                              }"
                              @click="save_comment(CommentUserLists.id)"
                            >
                              ثبت نظر
                            </div>
                            <div
                              v-if="
                                comment_btn_replay_loading[CommentUserLists.id]
                              "
                              class="commentBtn"
                              :class="{
                                disabled:
                                  comment_replay[CommentUserLists.id] === '',
                              }"
                            >
                              <span class="loader"></span>
                              <span style="margin-right: 5px"> ثبت نظر</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="commentsReplyToggler">
                        <div
                          class="commentsReplyToggleBtn"
                          @click="replyToggleHandler(i)"
                        >
                          <VsxIcon
                            v-show="i !== showReply"
                            iconName="ArrowDown2"
                            :size="20"
                            color="#0096c7"
                            type="linear"
                          />
                          <VsxIcon
                            v-show="i === showReply"
                            iconName="ArrowUp2"
                            :size="20"
                            color="#0096c7"
                            type="linear"
                          />
                          {{ CommentUserLists.replay.length }} پاسخ
                        </div>
                      </div>
                      <div
                        class="commentsReply"
                        :class="{ show: showReply === i }"
                      >
                        <div
                          class="commentThumb"
                          v-for="(replay, i) in CommentUserLists.replay"
                          :key="i"
                        >
                          <div class="commentProfile"></div>
                          <div class="commentContent">
                            <div class="commentHeader">
                              <h6 class="userName">{{ replay.name }}</h6>
                              <div class="commentDate">{{ replay.date }}</div>
                            </div>
                            <div class="commentText">
                              {{ replay.description }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="loadeMoreLoader" v-if="loadmore_loading">
                    <span class="custom-loader"></span>
                  </div>
                  <div
                    v-show="CommentUserList.length !== 0 && loadMore"
                    ref="loadMoreTrigger"
                    class="trigger"
                  ></div>
                </div>
              </div>
            </section>
          </section>
        </div>
        <div class="accommodation-pdp-content__sidebar">
          <aside class="accommodation-pdp-sidebar">
            <div class="accommodation-pdp-sidebar__container">
              <div class="accommodation-pdp-sidebar-info">
                <div class="accommodation-pdp-sidebar-info-price">
                  <div class="accommodation-pdp-sidebar-info-price-amount">
                    <div>
                      <span
                        v-if="
                          post_datail && post_datail.main_category_en == 'trade'
                        "
                      >
                        قیمت :</span
                      >
                      <strong
                        v-if="
                          post_datail && post_datail.main_category_en == 'trade'
                        "
                        class="accommodation-pdp-sidebar-info-price-amount__price"
                      >
                        {{ post_datail?.total_price }}
                      </strong>
                    </div>
                    <div>
                      <span
                        v-if="
                          post_datail &&
                          post_datail.main_category_en == 'request' &&
                          post_datail.request_type_en == 'buy'
                        "
                      >
                        قیمت :</span
                      >
                      <strong
                        v-if="
                          post_datail &&
                          post_datail.main_category_en == 'request' &&
                          post_datail.request_type_en == 'buy'
                        "
                        class="accommodation-pdp-sidebar-info-price-amount__price"
                      >
                        {{ post_datail?.total_price }} تا
                        {{ post_datail?.total_price_max }}
                      </strong>
                    </div>

                    <div>
                      <span
                        v-if="
                          post_datail &&
                          post_datail.main_category_en == 'request' &&
                          post_datail.request_type_en == 'rent'
                        "
                      >
                        قیمت رهن:</span
                      >
                      <strong
                        v-if="
                          post_datail &&
                          post_datail.main_category_en == 'request' &&
                          post_datail.request_type_en == 'rent'
                        "
                        class="accommodation-pdp-sidebar-info-price-amount__price"
                      >
                        {{ post_datail?.mortgage_price }} تا
                        {{ post_datail?.mortgage_price_max }}
                      </strong>
                    </div>
                    <div>
                      <span
                        v-if="
                          post_datail && post_datail.main_category_en == 'rent'
                        "
                      >
                        قیمت رهن:</span
                      >
                      <strong
                        v-if="
                          post_datail && post_datail.main_category_en == 'rent'
                        "
                        class="accommodation-pdp-sidebar-info-price-amount__price"
                      >
                        {{ post_datail?.mortgage_price }}
                      </strong>
                    </div>

                    <div>
                      <span
                        v-if="
                          post_datail &&
                          post_datail.main_category_en == 'request' &&
                          post_datail.request_type_en == 'rent'
                        "
                      >
                        قیمت اجاره:</span
                      >
                      <strong
                        v-if="
                          post_datail &&
                          post_datail.main_category_en == 'request' &&
                          post_datail.request_type_en == 'rent'
                        "
                        class="accommodation-pdp-sidebar-info-price-amount__price"
                      >
                        {{ post_datail?.rent_price }} تا
                        {{ post_datail?.rent_price_max }}
                      </strong>
                    </div>
                    <div>
                      <span
                        v-if="
                          post_datail && post_datail.main_category_en == 'rent'
                        "
                      >
                        قیمت اجاره:</span
                      >
                      <strong
                        v-if="
                          post_datail && post_datail.main_category_en == 'rent'
                        "
                        class="accommodation-pdp-sidebar-info-price-amount__price"
                      >
                        {{ post_datail?.rent_price }}
                      </strong>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="post_datail && post_datail.consultants"
                class="accommodation-pdp-sidebar__wrapper"
              >
                <div class="accommodation-pdp-sidebar-box">
                  <div class="accommodation-pdp-sidebar-calendar">
                    <div class="AllAvatarShowTOUser">
                      <div class="AvatarShowTOUser">
                        <img
                          :src="post_datail?.branch_avatar"
                          alt="تصویر املاک"
                          loading="lazy"
                          class="pdp-host-info-avatar__image"
                        />
                      </div>
                      <div>
                        <p>
                          {{ post_datail?.branch_title }}
                        </p>

                        <span
                          v-if="
                            post_datail &&
                            post_datail.feature &&
                            post_datail.feature.includes('showphone')
                          "
                          class="desktopPhoneNumber"
                        >
                          {{ post_datail?.contact }}
                        </span>
                        <span
                          v-if="
                            post_datail &&
                            post_datail.feature &&
                            !post_datail.feature.includes('showphone')
                          "
                          class="desktopPhoneNumber"
                        >
                          09xxxxxxxxx
                        </span>
                      </div>
                    </div>

                    <div style="display: flex; align-items: center">
                      <div style="margin-left: 8px">
                        <VsxIcon
                          v-if="!$store.getters.auth.loggedIn"
                          @click="showLoginBox"
                          iconName="Messages2"
                          :size="24"
                          color="#0096c7"
                          type="bold"
                        />
                        <VsxIcon
                          v-if="$store.getters.auth.loggedIn"
                          @click="
                            open_chat(
                              post_datail?.user_id,
                              post_datail?.main_category_en,
                            )
                          "
                          iconName="Messages2"
                          :size="24"
                          color="#0096c7"
                          type="bold"
                        />
                      </div>
                      <a
                        :href="`tel:${post_datail?.contact}`"
                        style="margin-left: 8px"
                      >
                        <VsxIcon
                          iconName="CallCalling"
                          :size="24"
                          color="#0096c7"
                          type="bold"
                        />
                      </a>

                      <a :href="`sms:${post_datail?.contact}`">
                        <VsxIcon
                          iconName="Message"
                          :size="24"
                          color="#0096c7"
                          type="bold"
                        />
                      </a>
                    </div>
                  </div>
                  <div
                    class="optionButtonsWrapper"
                    :class="{ singleColumn: !showRequest }"
                  >
                    <div
                      v-if="
                        showRequest &&
                        post_datail.main_category_en != 'request' &&
                        !requestLoading &&
                        $store.state.auth.loggedIn
                      "
                      class="requestBtn"
                      @click="setRequestVistHandler"
                    >
                      درخواست بازدید
                    </div>
                    <div
                      v-else-if="
                        showRequest &&
                        post_datail.main_category_en != 'request' &&
                        !requestLoading &&
                        !$store.state.auth.loggedIn
                      "
                      class="requestBtn"
                      @click="showLoginBox"
                    >
                      درخواست بازدید
                    </div>
                    <div
                      v-else-if="showRequest && requestLoading"
                      class="requestBtn"
                    >
                      <div class="loader"></div>
                    </div>
                    <router-link to="/contact-us" class="reportBtn">
                      گزارش تخلف
                    </router-link>
                  </div>
                  <div class="accommodation-pdp-sidebar-passengers"></div>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
      <div v-if="samePosts && samePosts.length > 0" class="suggestionList">
        <div class="suggestionListTitle">
          <div class="listTitle">آگهی‌های مشابه</div>
          <div class="listNavigation">
            <div class="customNav prevBtn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="size-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m8.25 4.5 7.5 7.5-7.5 7.5"
                />
              </svg>
            </div>
            <div class="customNav nextBtn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="size-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15.75 19.5 8.25 12l7.5-7.5"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="suggestionListWrapper">
          <Swiper
            :slides-per-view="'auto'"
            :space-between="20"
            :modules="modules"
            :navigation="{
              nextEl: '.nextBtn',
              prevEl: '.prevBtn',
            }"
          >
            <SwiperSlide v-for="(v, i) in samePosts" :key="i">
              <div class="propertyThumb" @click="showPost(v)">
                <div class="propertyPic">
                  <div class="propertyNums">
                    <div class="likesNum">
                      <div class="numsICON">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="size-6"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
                          />
                        </svg>
                      </div>
                      <div class="numNumber">{{ v.likes }}</div>
                    </div>
                    <div class="commentsNum">
                      <div class="numsICON">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="1.5"
                          stroke="currentColor"
                          class="size-6"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z"
                          />
                        </svg>
                      </div>
                      <div class="numNumber">{{ v.comments_count }}</div>
                    </div>
                  </div>
                  <img
                    :src="v.avatar"
                    :alt="v.content"
                    @error="handleImageError"
                  />
                </div>
                <div class="propertyContent">
                  <div class="contanteHeader">
                    <div class="propertyCategory">
                      {{ v.main_category }}
                      <span
                        v-if="
                          post_datail &&
                          post_datail.main_category_en == 'request'
                        "
                      >
                        {{ post_datail.request_type }}</span
                      >
                      - {{ v.category }}
                    </div>
                    <div class="propertyUpload">
                      <div class="propertyUploadIcon">
                        <VsxIcon
                          iconName="Calendar"
                          :size="14"
                          color="#0096c7"
                          type="linear"
                        />
                      </div>
                      <div class="propertyUploadTitle">{{ v.created_fa }}</div>
                    </div>
                  </div>
                  <div class="contentMain">
                    <div class="propertyTitle">{{ v.content }}</div>
                    <div class="propertyLocation">
                      <div class="locationIcon">
                        <i class="fa-solid fa-location-dot"></i>
                      </div>
                      <div class="locationTitle">
                        {{ v.address }}
                      </div>
                    </div>
                    <div class="contentFeaturesWrapper">
                      <div
                        v-if="v.feature && v.feature.includes('fast')"
                        class="featuresThumb fast"
                      >
                        <i class="fa-solid fa-bolt"></i>
                        <span>فوری</span>
                      </div>
                      <div
                        v-if="v.feature && v.feature.includes('exchangeable')"
                        class="featuresThumb exchange"
                      >
                        <i class="fa-solid fa-rotate"></i>
                        <span>قابل معاوضه</span>
                      </div>
                      <div
                        v-if="
                          v.feature &&
                          (v.feature.includes('single') ||
                            v.feature.includes('student'))
                        "
                        class="featuresThumb single"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          class="size-6"
                        >
                          <path
                            d="M11.7 2.805a.75.75 0 0 1 .6 0A60.65 60.65 0 0 1 22.83 8.72a.75.75 0 0 1-.231 1.337 49.948 49.948 0 0 0-9.902 3.912l-.003.002c-.114.06-.227.119-.34.18a.75.75 0 0 1-.707 0A50.88 50.88 0 0 0 7.5 12.173v-.224c0-.131.067-.248.172-.311a54.615 54.615 0 0 1 4.653-2.52.75.75 0 0 0-.65-1.352 56.123 56.123 0 0 0-4.78 2.589 1.858 1.858 0 0 0-.859 1.228 49.803 49.803 0 0 0-4.634-1.527.75.75 0 0 1-.231-1.337A60.653 60.653 0 0 1 11.7 2.805Z"
                          />
                          <path
                            d="M13.06 15.473a48.45 48.45 0 0 1 7.666-3.282c.134 1.414.22 2.843.255 4.284a.75.75 0 0 1-.46.711 47.87 47.87 0 0 0-8.105 4.342.75.75 0 0 1-.832 0 47.87 47.87 0 0 0-8.104-4.342.75.75 0 0 1-.461-.71c.035-1.442.121-2.87.255-4.286.921.304 1.83.634 2.726.99v1.27a1.5 1.5 0 0 0-.14 2.508c-.09.38-.222.753-.397 1.11.452.213.901.434 1.346.66a6.727 6.727 0 0 0 .551-1.607 1.5 1.5 0 0 0 .14-2.67v-.645a48.549 48.549 0 0 1 3.44 1.667 2.25 2.25 0 0 0 2.12 0Z"
                          />
                          <path
                            d="M4.462 19.462c.42-.419.753-.89 1-1.395.453.214.902.435 1.347.662a6.742 6.742 0 0 1-1.286 1.794.75.75 0 0 1-1.06-1.06Z"
                          />
                        </svg>
                        <span>دانشجو/مجرد</span>
                      </div>
                    </div>
                    <div class="contentPriceWrapper">
                      <div
                        class="priceWrapper"
                        v-if="
                          v.main_category_en != 'rent' &&
                          !(
                            v.main_category_en == 'request' &&
                            v.request_type_en == 'rent'
                          )
                        "
                      >
                        <div
                          class="pricecTitle"
                          v-if="v.main_category_en == 'trade'"
                        >
                          قیمت فروش:
                        </div>
                        <div
                          class="pricecTitle"
                          v-if="v.main_category_en == 'request'"
                        >
                          قیمت خرید:
                        </div>
                        <div
                          v-if="v.main_category_en != 'request'"
                          class="priceValue"
                        >
                          {{ v.total_price }}
                        </div>
                        <div
                          v-if="v.main_category_en == 'request'"
                          class="priceValue"
                        >
                          {{ v.total_price }} تا {{ v.total_price_max }}
                        </div>
                      </div>
                      <div
                        class="priceWrapper"
                        v-if="
                          v.main_category_en == 'rent' ||
                          (v.main_category_en == 'request' &&
                            v.request_type_en == 'rent')
                        "
                      >
                        <div class="pricecTitle">مبلغ رهن:</div>
                        <div
                          v-if="v.main_category_en != 'request'"
                          class="priceValue"
                        >
                          {{ v.mortgage_price }}
                        </div>
                        <div
                          v-if="v.main_category_en == 'request'"
                          class="priceValue"
                        >
                          {{ v.mortgage_price }} تا {{ v.mortgage_price_max }}
                        </div>
                      </div>
                      <div
                        class="priceWrapper"
                        v-if="
                          v.main_category_en == 'rent' ||
                          (v.main_category_en == 'request' &&
                            v.request_type_en == 'rent')
                        "
                      >
                        <div class="pricecTitle">مبلغ اجاره:</div>
                        <div
                          v-if="v.main_category_en != 'request'"
                          class="priceValue"
                        >
                          {{ v.rent_price }}
                        </div>
                        <div
                          v-if="v.main_category_en == 'request'"
                          class="priceValue"
                        >
                          {{ v.rent_price }} تا {{ v.rent_price_max }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
      <div class="contactBoxInfo">
        <div
          class="contactBoxInfoWrapper"
          :class="{
            twoColumn:
              !showRequest || post_datail.main_category_en == 'request',
          }"
        >
          <div
            v-if="!$store.getters.auth.loggedIn"
            class="contactInfoBtn btnLight"
            @click="showLoginBox"
          >
            چت
          </div>
          <div
            v-if="$store.getters.auth.loggedIn"
            class="contactInfoBtn btnLight"
            @click="
              open_chat(post_datail.user_id, post_datail.main_category_en)
            "
          >
            چت
          </div>
          <div class="contactInfoBtn btnLight" @click="openOptions">
            اطلاعات تماس
          </div>
          <div
            v-if="
              showRequest &&
              !requestLoading &&
              post_datail.main_category_en != 'request' &&
              $store.state.auth.loggedIn
            "
            class="contactInfoBtn"
            @click="setRequestVistHandler"
          >
            درخواست بازدید
          </div>
          <div
            v-else-if="
              showRequest &&
              !requestLoading &&
              post_datail.main_category_en != 'request' &&
              !$store.state.auth.loggedIn
            "
            class="contactInfoBtn"
            @click="showLoginBox"
          >
            درخواست بازدید
          </div>
          <div v-else-if="showRequest && requestLoading" class="contactInfoBtn">
            <div class="loader"></div>
          </div>
        </div>
      </div>
      <!--    mobile sheet-->
      <vue-bottom-sheet
        v-show="commentSheet"
        :open="commentSheet"
        ref="myBottomSheet"
        @close="closeBottomSheet"
      >
        <div class="ShowCommandBoxesMyBottomSheet">
          <el-scrollbar
            height="440px"
            class="commentListWrapper"
            @scroll="handleScrollComment"
          >
            <div
              v-for="(CommentUserLists, i) in CommentUserList"
              :key="i"
              class="AllChildCommentRefSheet"
            >
              <div class="ChildCommentRefSheetVg">
                <div class="ChildCommentRefSheet">
                  <div class="ImageChildCommentRefSheet">
                    <img
                      :src="CommentUserLists.avatar"
                      :alt="CommentUserLists.name"
                    />
                  </div>
                  <div class="TitleChildCommentRefSheet">
                    <h1>
                      {{ CommentUserLists.name }}
                    </h1>
                    <p>
                      {{ CommentUserLists.description }}
                    </p>
                  </div>
                </div>

                <VsxIcon
                  iconName="MessageAdd1"
                  :size="25"
                  color="#0096c7"
                  type="bold"
                  @click="replay_focuse(CommentUserLists.id)"
                />
              </div>
              <div class="repliesList">
                <div
                  v-for="(replaies, i) in CommentUserLists.replay"
                  :key="i"
                  class="ReplayChildCommentRefSheet"
                >
                  <VsxIcon
                    style="margin-left: 10px"
                    iconName="Data2"
                    :size="20"
                    color="#999"
                    type="linear"
                  />
                  <div class="ImageChildCommentRefSheet">
                    <img :src="replaies.avatar" :alt="replaies.name" />
                  </div>
                  <div class="TitleChildCommentRefSheet">
                    <h1>
                      {{ replaies.name }}
                    </h1>
                    <p>
                      {{ replaies.description }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="mobileNocomments"
              v-if="CommentUserList.length == 0 && !loadmore_loading"
            >
              نظری ثبت نشده است
            </div>
            <div class="loadeMoreLoader" v-if="loadmore_loading">
              <span class="custom-loader"></span>
            </div>
          </el-scrollbar>

          <div class="dentMessageToCommentSpace"></div>

          <div
            v-if="!$store.getters.auth.loggedIn"
            class="dentMessageToComment"
          >
            <span class="loginMessage">
              برای ثبت نظر وارد حساب کاربری شوید
            </span>
          </div>
          <div v-else class="dentMessageToComment">
            <div class="sendCommentBtnWrapper">
              <div
                class="sendCommentBtn"
                v-if="!comment_btn_loading && !$store.state.auth.loggedIn"
                @click="showLoginBox"
              >
                <i class="fa-solid fa-paper-plane"></i>
              </div>
              <div
                class="sendCommentBtn"
                v-if="!comment_btn_loading && $store.state.auth.loggedIn"
                @click="save_comment(0, 'mob')"
              >
                <i class="fa-solid fa-paper-plane"></i>
              </div>

              <span v-if="comment_btn_loading" class="loader"></span>
            </div>

            <div class="mobileNewCommentInput">
              <input
                type="text"
                id="newComment_mob"
                v-model="newComment"
                :style="parent_id === 0 ? 'width: 100%;' : 'width: 82%'"
              />
            </div>
            <div
              v-if="parent_id !== 0"
              class="cancleReply"
              @click="replay_blur"
            >
              انصراف
            </div>
          </div>
        </div>
      </vue-bottom-sheet>
      <vue-bottom-sheet :open="optionSheet" ref="myOptionSheet">
        <div class="mobileOptionsWrapper">
          <a :href="`tel:${post_datail?.contact}`" class="mobileOption">
            <div class="optionIcon">
              <i class="fa-solid fa-phone"></i>
            </div>
            <!--          0:"showphone"-->
            <!--          v-if="myArray.includes('a')"-->

            <div
              class="optionTitle"
              v-if="
                post_datail &&
                post_datail.feature &&
                post_datail.feature.includes('showphone')
              "
            >
              تماس تلفنی با {{ post_datail?.contact }}
            </div>
            <div
              class="optionTitle"
              v-if="
                post_datail &&
                post_datail.feature &&
                !post_datail.feature.includes('showphone')
              "
            >
              تماس تلفنی با 09xxxxxxxxx
            </div>
          </a>
          <a :href="`sms:${post_datail?.contact}`" class="mobileOption">
            <div class="optionIcon">
              <i class="fa-solid fa-message"></i>
            </div>
            <div
              class="optionTitle"
              v-if="
                post_datail &&
                post_datail.feature &&
                post_datail.feature.includes('showphone')
              "
            >
              ارسال پیامک به {{ post_datail?.contact }}
            </div>
            <div
              class="optionTitle"
              v-if="
                post_datail &&
                post_datail.feature &&
                !post_datail.feature.includes('showphone')
              "
            >
              ارسال پیامک به 09xxxxxxxxx
            </div>
          </a>
        </div>
      </vue-bottom-sheet>
      <LoginUser @close="ShowLoginBoxes = false" v-if="ShowLoginBoxes" />
    </div>
    <blockLoading v-if="showLoading" />
  </div>
</template>

<script>
import detailsImage from "../components/detailsImage/detailsImage.vue";
import { toast } from "vue3-toastify";
import axios from "axios";
import "vue3-toastify/dist/index.css";
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import "@webzlodimir/vue-bottom-sheet/dist/style.css";
import { nextTick } from "vue";
import "leaflet/dist/leaflet.css";
import { Share } from "@capacitor/share";
import LoginUser from "./LoginUser.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation } from "swiper/modules";
import "swiper/css/navigation";
import "swiper/css";
import blockLoading from "@/components/blockLoading/blockLoading.vue";
import L from "leaflet";
import "leaflet.markercluster";
import maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import "@maplibre/maplibre-gl-leaflet";

try {
  if (maplibregl) {
    maplibregl.setRTLTextPlugin(
      "./js/mapbox-gl-rtl-text.js",
      null,
      true,
    );
  }
} catch (_e) {
  console.error(_e)
}


export default {
  name: "DetailsPost",
  components: {
    detailsImage,
    VueBottomSheet,
    LoginUser,
    Swiper,
    SwiperSlide,
    blockLoading,
  },
  data() {
    return {
      likeLoading: false,
      authDetails: null,
      showLoading: false,
      modules: [Navigation],
      optionSheet: false,
      post_datail: null,
      showgallary: false,
      desktopCommentsModal: false,
      urlToShare: "",
      title: "My Awesome App",
      text: "",
      commentSheet: false,
      addComentModal: false,
      isFocus: false,
      comment_btn_loading: false,
      ShowLoginBoxes: false,
      newComment: "",
      showReply: -1,
      mobileShowReply: -1,
      replyComment: -1,
      CommentUserList: [],
      samePosts: [],
      map: null,
      leafletMap: null,
      mapInitialized: false,
      mapInitStarted: false,
      houseSvg: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="67" height="67" viewBox="0 0 67 67">
        <defs>
            <filter id="cxwfhygxxa" width="211.1%" height="211.1%" x="-55.6%" y="-55.6%" filterUnits="objectBoundingBox">
                <feOffset in="SourceAlpha" result="shadowOffsetOuter1"/>
                <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="5"/>
                <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.461511145 0"/>
                <feMerge>
                    <feMergeNode in="shadowMatrixOuter1"/>
                    <feMergeNode in="SourceGraphic"/>
                </feMerge>
            </filter>
            <path id="m1l7efvoab" d="M15.317 5.098L8.435.183c-.341-.244-.8-.244-1.142 0L.412 5.098c-.442.316-.544.93-.229 1.371.315.443.93.544 1.371.23l.412-.295v8.341c0 .543.44.983.983.983h9.83c.544 0 .983-.44.983-.983v-8.34c.343.244.587.476.982.476.308 0 .61-.143.801-.412.316-.441.213-1.055-.228-1.371zm-3.52 8.664H9.83v-2.949c0-1.086-.88-1.966-1.966-1.966-1.086 0-1.966.88-1.966 1.966v2.95H3.932V5L7.864 2.19 11.796 5v8.762z"/>
        </defs>
        <g fill="none" fill-rule="evenodd" filter="url(#cxwfhygxxa)" transform="translate(15.127 15.127)">
            <rect width="32.887" height="32.887" x="1.43" y="1.43" fill="#213743" stroke="#192B37" stroke-width="2.86" rx="8.579"/>
            <g transform="translate(10.009 10.009)">
                <mask id="wd87vlifuc" fill="#fff">
                    <use xlink:href="#m1l7efvoab"/>
                </mask>
                <use fill="#000" fill-rule="nonzero" xlink:href="#m1l7efvoab"/>
                <g fill="#FFF" mask="url(#wd87vlifuc)">
                    <path d="M0 0H15.728V15.728H0z"/>
                </g>
            </g>
        </g>
      </svg>`,
      houseSvgDataUrl: null,
      datepicker: null,
      markersLayer: null,
      markerOne: null,
      loadMoreTrigger: null,
      markerPosition: { longitude: 0, latitude: 0 },
      fillter: {
        main_category: "all",
        category: "all", //commercial
        bed: -1,
        view_mode: "list",
        user_id: 0,
        m_id: 0,
        per_page: "get",
      },
      comment_replay: [],
      comment_btn_replay_loading: [],
      parent_id: 0,
      publicPath: process.env.VUE_APP_PUBLIC_PATH,
      page: 1,
      isLoading: true,
      loadmore: false,
      loadmore_loading: false,
      total: 0,
      requestLoading: false,
      loadingFollow: false,
      houseIcon: L.divIcon({
        html: `
          <div style="position: relative;">
            <div style="
              position: absolute;
              width: 70px;
              height: 70px;
              background: rgba(0, 0, 0, 0.2);
              border-radius: 50%;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            "></div>
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="67" height="67" viewBox="0 0 67 67">
              <defs>
                  <filter id="cxwfhygxxa" width="211.1%" height="211.1%" x="-55.6%" y="-55.6%" filterUnits="objectBoundingBox">
                      <feOffset in="SourceAlpha" result="shadowOffsetOuter1"/>
                      <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="5"/>
                      <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.461511145 0"/>
                      <feMerge>
                          <feMergeNode in="shadowMatrixOuter1"/>
                          <feMergeNode in="SourceGraphic"/>
                      </feMerge>
                  </filter>
                  <path id="m1l7efvoab" d="M15.317 5.098L8.435.183c-.341-.244-.8-.244-1.142 0L.412 5.098c-.442.316-.544.93-.229 1.371.315.443.93.544 1.371.23l.412-.295v8.341c0 .543.44.983.983.983h9.83c.544 0 .983-.44.983-.983v-8.34c.343.244.587.476.982.476.308 0 .61-.143.801-.412.316-.441.213-1.055-.228-1.371zm-3.52 8.664H9.83v-2.949c0-1.086-.88-1.966-1.966-1.966-1.086 0-1.966.88-1.966 1.966v2.95H3.932V5L7.864 2.19 11.796 5v8.762z"/>
              </defs>
              <g fill="none" fill-rule="evenodd" filter="url(#cxwfhygxxa)" transform="translate(15.127 15.127)">
                  <rect width="32.887" height="32.887" x="1.43" y="1.43" fill="#213743" stroke="#192B37" stroke-width="2.86" rx="8.579"/>
                  <g transform="translate(10.009 10.009)">
                      <mask id="wd87vlifuc" fill="#fff">
                          <use xlink:href="#m1l7efvoab"/>
                      </mask>
                      <use fill="#000" fill-rule="nonzero" xlink:href="#m1l7efvoab"/>
                      <g fill="#FFF" mask="url(#wd87vlifuc)">
                          <path d="M0 0H15.728V15.728H0z"/>
                      </g>
                  </g>
              </g>
          </svg>

          </div>`,
        className: "house-marker",
        iconSize: [70, 70],
        iconAnchor: [35, 35],
      }),
    };
  },
  computed: {
    formattedDetails() {
      return this.post_datail.details.replace(/(\r\n|\n|\r)/g, "<br>");
    },
    showRequest() {
      return this.post_datail &&
        this.post_datail.request_visit &&
        this.post_datail.request_visit2
        ? true
        : false;
    },
  },
  created() {
    try {
      this.houseSvgDataUrl =
        "data:image/svg+xml;utf8," + encodeURIComponent(this.houseSvg);
    } catch (e) {
      this.houseSvgDataUrl = null;
    }

    this.houseIcon = L.divIcon({
      html: `
      <div style="position: relative;">
        <div style="
          position: absolute;
          width: 70px;
          height: 70px;
          background: rgba(0, 0, 0, 0.2);
          border-radius: 50%;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        "></div>
        ${this.houseSvg}
      </div>`,
      className: "house-marker",
      iconSize: [70, 70],
      iconAnchor: [35, 35],
    });
  },
  methods: {
    handleScrollComment() {
      const scrollbarWrap = this.$refs.scrollbar?.wrapRef;

      if (!scrollbarWrap) return;

      const scrollTop = scrollbarWrap.scrollTop;
      const scrollHeight = scrollbarWrap.scrollHeight;
      const clientHeight = scrollbarWrap.clientHeight;

      if (scrollTop + clientHeight + 100 >= scrollHeight) {
        if (this.loadmore && !this.loadmore_loading) {
          this.load_postComment();
        }
      }

      if (scrollTop > 100) {
        this.divTop = "top:20px; width:85%;margin: 0;right: 5%";
      } else {
        this.divTop = "top:80px; width:90%;margin: auto";
      }
    },
    getSamePosts(id) {
      axios
        .get(this.$store.getters.baseUrl + "/same-posts?post_id=" + id)
        .then((response) => {
          console.log("آگهی مشابه:", response.data);
          if (response.data.result == 1) {
            if (response.data.data.length != 0) {
              this.samePosts = response.data.data.list.filter(
                (item) => item.id != id,
              );
            }
          }
        })
        .catch((error) => {
          console.error("خطا در دریافت آگهی مشابه:", error);
        });
    },
    openOptions() {
      this.$refs.myOptionSheet.open();
    },
    showLoginBox() {
      this.$refs.myBottomSheet.close();
      this.commentSheet = false;
      this.$nextTick(() => {
        this.ShowLoginBoxes = true;
      });
    },
    destroyMap() {
      try {
        if (this.leafletMap) {
          this.removeHouseMarkerLeaflet();
          this.leafletMap.off();
          this.leafletMap.remove();
          this.leafletMap = null;
        }
      } catch (e) {
        console.error(e);
      }
      this.map = null;
      this.mapInitialized = false;
      this.mapInitStarted = false;
    },
    addHouseMarkerLeaflet(lat, lng) {
      // remove previous
      if (this.leafletHouseMarker && this.leafletMap) {
        try {
          this.leafletMap.removeLayer(this.leafletHouseMarker);
        } catch (e) {
          console.error(e);
        }
        this.leafletHouseMarker = null;
      }
      if (!this.leafletMap) return;
      this.leafletHouseMarker = L.marker([lat, lng], {
        icon: this.houseIcon,
      }).addTo(this.leafletMap);
    },
    removeHouseMarkerLeaflet() {
      if (this.leafletHouseMarker && this.leafletMap) {
        try {
          this.leafletMap.removeLayer(this.leafletHouseMarker);
        } catch (e) {
          console.error(e);
        }
        this.leafletHouseMarker = null;
      }
    },
    async initializeMap() {
      if (this.leafletMap) {
        this.destroyMap();
      }

      if (
        !this.post_datail ||
        !this.post_datail.lat ||
        !this.post_datail.lng
      ) {
        return;
      }

      try {
        const mapirToken =
          this.$store.state.c_set?.map_info?.mapir_key ||
          this.$store.state.c_set?.mapir_key ||
          "";

        this.leafletMap = L.map("map", {
          dragging: !!(
            this.post_datail.feature &&
            this.post_datail.feature.includes("showmap")
          ),
          touchZoom: !!(
            this.post_datail.feature &&
            this.post_datail.feature.includes("showmap")
          ),
          scrollWheelZoom: !!(
            this.post_datail.feature &&
            this.post_datail.feature.includes("showmap")
          ),
          doubleClickZoom: !!(
            this.post_datail.feature &&
            this.post_datail.feature.includes("showmap")
          ),
          boxZoom: !!(
            this.post_datail.feature &&
            this.post_datail.feature.includes("showmap")
          ),
          keyboard: !!(
            this.post_datail.feature &&
            this.post_datail.feature.includes("showmap")
          ),
          zoomControl: !!(
            this.post_datail.feature &&
            this.post_datail.feature.includes("showmap")
          ),
          maxZoom: 19,
        }).setView(
          [this.post_datail.lat, this.post_datail.lng],
          16,
        );

        if (mapirToken) {
          L.maplibreGL({
            style:
              "https://map.ir/vector/styles/main/mapir-xyz-style.json?x-api-key=" +
              mapirToken,
            transformRequest: (url) => {
              return {
                url: url,
                headers: { "x-api-key": mapirToken },
              };
            },
            attribution:
              '<span dir="ltr">© <a href="https://map.ir">map.ir</a></span>',
            maxZoom: 19,
          }).addTo(this.leafletMap);
        } else {
          L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            maxZoom: 20,
            minZoom: 5,
            attribution: "© OpenStreetMap",
          }).addTo(this.leafletMap);
        }

        this.addHouseMarkerLeaflet(
          this.post_datail.lat,
          this.post_datail.lng,
        );

        this.map = this.leafletMap;
        this.mapInitialized = true;
      } catch (error) {
        console.error("Map initialization error:", error);
      }
    },
    replay_focuse(parent_id = 0) {
      this.parent_id = parent_id;
      document.getElementById("newComment_mob").focus();
    },
    replay_blur() {
      this.parent_id = 0;
      this.newComment = "";
      if (document.getElementById("newComment_mob")) {
        document.getElementById("newComment_mob").blur();
      }
    },
    save_comment(parent_id = 0, from) {
      if (!this.$store.state.auth.loggedIn) {
        toast("برای ثبت نظر وارد حساب کاربری خود شوید", {
          type: "error",
        });
        return;
      }
      if (
        this.post_datail &&
        this.post_datail.user_id &&
        this.$store.state.auth.loggedIn &&
        this.parent_id == 0
      ) {
        if (this.post_datail.user_id == this.$store.state.auth.uid) {
          this.newComment = "";
          toast("امکان ثبت نظر برای آگهی‌های متعلق به خودتان وجود ندارد.", {
            type: "error",
          });
          return;
        }
      }
      let self = this;
      const formData = new FormData();

      formData.append("related_id", this.post_datail.id);
      formData.append("related_to", "post");

      if (this.$store.state.auth.loggedIn)
        formData.append("author_id", this.$store.state.auth.uid);

      // تعیین parent_id برای ریپلای
      const actualParentId = from === "mob" ? this.parent_id : parent_id;

      if (actualParentId !== 0) {
        formData.append("parent_id", actualParentId);
        formData.append(
          "newComment",
          from === "mob"
            ? this.newComment
            : this.comment_replay[actualParentId],
        );
        self.comment_btn_replay_loading[actualParentId] = true;
      } else {
        formData.append("newComment", this.newComment);
        self.comment_btn_loading = true;
      }

      self.helperPost("save-comment", formData).then((r) => {
        if (r.data.result == "success") {
          // Create new comment object
          // const newComment = {
          //   id: r.data.id || Date.now(),
          //   name: self.$store.state.auth.name || "کاربر",
          //   avatar: self.$store.state.auth.avatar || "",
          //   description:
          //     actualParentId !== 0
          //       ? from === "mob"
          //         ? this.newComment
          //         : this.comment_replay[actualParentId]
          //       : this.newComment,
          //   date: new Date().toLocaleDateString("fa-IR"),
          //   replay: [],
          // };

          if (actualParentId !== 0) {
            // Add reply to parent comment
            // const parentComment = self.CommentUserList.find(
            //   (comment) => comment.id === actualParentId
            // );
            if (from === "mob") {
              self.newComment = "";
            } else {
              self.comment_replay[actualParentId] = "";
            }
          } else {
            // Add new comment to end of list
            self.newComment = "";
          }

          self.replyCommentCloseHandler();
          // self.total += 1;

          toast(
            "نظر شما با موفقیت ثبت شد و پس از تأیید مدیریت نمایش داده خواهد شد.",
            {
              type: "success",
            },
          );
          self.parent_id = 0;
        } else {
          toast(r.data.msg, {
            type: "error",
            dangerouslyHTMLString: true,
          });
        }
        self.comment_btn_replay_loading[actualParentId] = false;
        self.comment_btn_loading = false;
      });
    },
    // save_comment(parent_id = 0, from) {
    //   let self = this;
    //   const formData = new FormData();

    //   formData.append("related_id", this.post_datail.id);
    //   formData.append("related_to", "post");

    //   if (this.$store.state.auth.loggedIn)
    //     formData.append("author_id", this.$store.state.auth.uid);

    //   if (parent_id) {
    //     formData.append("parent_id", parent_id);
    //     formData.append("newComment", this.comment_replay[parent_id]);
    //     self.comment_btn_replay_loading[parent_id] = true;
    //   } else {
    //     if (from == "mob") formData.append("parent_id", this.parent_id);
    //     formData.append("newComment", this.newComment);
    //     self.comment_btn_loading = true;
    //   }

    //   self.helperPost("save-comment", formData).then((r) => {
    //     if (r.data.result == "success") {
    //       self.newComment = "";
    //       this.replyCommentCloseHandler();
    //       toast("نظر شما با موفقیت ثبت شد", {
    //         type: "success",
    //         dangerouslyHTMLString: true,
    //       });
    //       this.parent_id = 0;
    //       this.load_postComment();
    //     } else {
    //       toast(r.data.msg, {
    //         type: "error",
    //         dangerouslyHTMLString: true,
    //       });
    //     }
    //     self.comment_btn_replay_loading[parent_id] = false;
    //     self.comment_btn_loading = false;
    //   });
    // },
    load_postComment(param) {
      let self = this;
      this.loadmore = true;
      this.loadmore_loading = true;
      this.page += 1;
      if (param == "first") {
        this.isLoading = true;
        this.CommentUserList = [];
        this.page = 1;
      }

      this.helperGet(
        "get-comment",
        "related_to=post" +
          "&related_id=" +
          this.post_datail.id +
          "&page=" +
          this.page,
      ).then((res) => {
        if (res.data.result == 1) {
          this.total = res.data.data.total;
          // اضافه کردن کامنت‌های جدید به انتهای لیست
          const newComments = [...res.data.data.list].reverse(); // معکوس کردن ترتیب کامنت‌ها
          self.CommentUserList = self.CommentUserList.concat(newComments);

          if (res.data.data.total_page == self.page) {
            this.loadmore = false;
          }
          self.comment_btn_replay_loading = [];
          self.CommentUserList.forEach(function (v) {
            self.comment_btn_replay_loading[v.id] = false;
          });
        }

        this.isLoading = false;
        this.loadmore_loading = false;
      });
    },
    // load_postComment(param) {
    //   let self = this;
    //   this.loadmore = true;
    //   this.loadmore_loading = true;
    //   this.page += 1;
    //   if (param == "first") {
    //     this.isLoading = true;
    //     this.CommentUserList = [];
    //     this.page = 1;
    //   }

    //   this.helperGet(
    //     "get-comment",
    //     "related_to=post" +
    //       "&related_id=" +
    //       this.post_datail.id +
    //       "&page=" +
    //       this.page
    //   ).then((res) => {
    //     if (res.data.result == 1) {
    //       this.total = res.data.data.total;
    //       self.CommentUserList = self.CommentUserList.concat(
    //         res.data.data.list
    //       );
    //       if (res.data.data.total_page == self.page) {
    //         this.loadmore = false;
    //       }
    //       self.comment_btn_replay_loading = [];
    //       self.CommentUserList.forEach(function (v) {
    //         self.comment_btn_replay_loading[v.id] = false;
    //       });
    //     }

    //     this.isLoading = false;
    //     this.loadmore_loading = false;
    //   });
    // },

    load_postInfo(id) {
      let self = this;
      self.fillter.m_id = id;
      self.fillter.list_type = "";
      self.fillter.user_id = this.$store.state.auth.loggedIn
        ? this.$store.state.auth.uid
        : 0;
      self.helperPost("public-post-list", self.fillter).then((r) => {
        self.post_datail = r.data.data.list[0];
        console.log("second", r.data.data.list[0]);
        if (
          this.post_datail &&
          this.post_datail.photo_galleries &&
          this.post_datail.photo_galleries.length
        ) {
          this.showgallary = true;
          this.urlToShare =
            "https://shomalamlak.ir/details/" + this.post_datail.id;
          this.$store.commit("post_detail_set", r.data.data.list[0]);
          this.load_postComment("first");
          setTimeout(() => {
            // this.getmounted();
            this.initializeMap();
          }, 500);
        }
        this.showLoading = false;
      });
    },
    loadArchivePost(id) {
      let self = this;
      self.fillter.m_id = id;
      self.fillter.list_type = "own_profile";
      self.fillter.user_id = this.$store.state.auth.loggedIn
        ? this.$store.state.auth.uid
        : 0;
      self.helperPost("post-list", self.fillter).then((r) => {
        self.post_datail = r.data.data.list[0];
        console.log("second", r.data.data.list[0]);
        if (
          this.post_datail &&
          this.post_datail.photo_galleries &&
          this.post_datail.photo_galleries.length
        ) {
          this.showgallary = true;
          this.urlToShare =
            "https://shomalamlak.ir/details/" + this.post_datail.id;
          this.$store.commit("post_detail_set", r.data.data.list[0]);
          this.load_postComment("first");
          setTimeout(() => {
            // this.getmounted();
            this.initializeMap();
          }, 500);
        }
        this.showLoading = false;
      });
    },
    inputFocusHandler() {
      this.isFocus = !this.isFocus;
    },
    replyToggleHandler(index) {
      if (this.showReply === index) {
        this.showReply = -1;
      } else {
        this.showReply = index;
      }
    },
    mobileReplyToggleHandler(index) {
      if (this.mobileShowReply === index) {
        this.mobileShowReply = -1;
      } else {
        this.mobileShowReply = index;
      }
    },
    replyCommentHandler(index) {
      this.replyComment = index;
    },
    replyCommentCloseHandler() {
      this.replyComment = -1;
    },
    // getmounted(map) {
    //   this.map = map;
    //   this.initializeMap(map);
    // },

    desktopMOdalHandler() {
      if (this.desktopCommentsModal) {
        this.desktopCommentsModal = false;
        document.body.style.overflow = "auto";
      } else {
        this.desktopCommentsModal = true;
        document.body.style.overflow = "hidden";
      }
    },
    addComentModalHandler() {
      if (this.addComentModal) {
        this.addComentModal = false;
      } else {
        this.addComentModal = true;
      }
    },
    OpenMessage() {
      this.$refs.myBottomSheet.open();
      this.commentSheet = true;
    },
    async shareContent() {
      if (this.$store.state.device == "Desktop") {
        const textToCopy = this.urlToShare + " - " + this.post_datail.content;
        const shareUrl = document.createElement("textarea");
        shareUrl.value = textToCopy;
        document.body.appendChild(shareUrl);

        shareUrl.select();
        document.execCommand("copy");
        document.body.removeChild(shareUrl);

        toast("متن اشتراک گذاری کپی شد.", {
          type: "success",
          dangerouslyHTMLString: true,
        });
      } else {
        try {
          await Share.share({
            title: this.title,
            text: this.text,
            url: this.urlToShare + " - " + this.post_datail.content,
            dialogTitle: "شمال املاک",
          });
        } catch (error) {
          console.error("خطا در اشتراک‌گذاری:", error);
        }
      }
    },

    btnCopyText() {
      const textToCopy = this.post_datail.details;
      const textarea = document.createElement("textarea");
      textarea.value = textToCopy;
      document.body.appendChild(textarea);

      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);

      toast("متن مورد نظر کپی شد.", {
        type: "success",
        dangerouslyHTMLString: true,
      });
    },
    save_favorit(post_id) {
      var user_id = 0;
      if (this.$store.state.auth.loggedIn) {
        user_id = this.$store.state.auth.uid;
        this.helperGet(
          "save-favorite",
          "post_id=" + post_id + "&user_id=" + user_id,
        ).then((r) => {
          this.post_datail.is_favorite = r.data.result;
          localStorage.removeItem("post_detail");
          this.$store.commit("post_detail_set", this.post_datail);
        });
      } else {
        this.$store.state.login_modal = true;
      }
    },

    save_like(post_id) {
      var user_id = 0;
      if (!this.$store.state.auth.loggedIn) {
        toast("برای لایک کردن آگهی وارد حساب کاربری خود شوید.", {
          type: "error",
        });
        return;
      }
      if (
        this.post_datail &&
        this.post_datail.user_id &&
        this.$store.state.auth.loggedIn
      ) {
        if (this.post_datail.user_id == this.$store.state.auth.uid) {
          toast("امکان لایک کردن آگهی‌های متعلق به خودتان وجود ندارد.", {
            type: "error",
          });
          return;
        }
      }
      if (this.$store.state.auth.loggedIn) {
        user_id = this.$store.state.auth.uid;
        this.likeLoading = true;
        this.helperGet(
          "save-like",
          "post_id=" + post_id + "&user_id=" + user_id,
        )
          .then((r) => {
            this.post_datail.is_like = r.data.result;
            if (r.data.result == 1) this.post_datail.likes -= 1;

            if (r.data.result == 2) this.post_datail.likes += 1;
            this.likeLoading = false;
            localStorage.removeItem("post_detail");
            this.$store.commit("post_detail_set", this.post_datail);
          })
          .catch((error) => {
            console.error(error);
            this.likeLoading = false;
          });
      } else {
        this.$store.state.login_modal = true;
      }
    },

    follow(target_id) {
      var user_id = 0;
      if (this.$store.state.auth.loggedIn) {
        this.loadingFollow = true;
        if (target_id) {
          user_id = this.$store.state.auth.uid;
          this.helperPost("follow", {
            uid: user_id,
            target_id: target_id,
          }).then((r) => {
            this.post_datail.is_follow = r.data.result;
            this.loadingFollow = false;
            localStorage.removeItem("post_detail");
            this.$store.commit("post_detail_set", this.post_datail);
          });
        }
      } else {
        this.ShowLoginBoxes = true;
        this.$store.state.login_modal = true;
      }
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(",", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    closeBottomSheet() {
      this.commentSheet = false;
    },
    open_chat(uid, main_cat) {
      this.$router.push({ path: "/chat", query: { uid, main_cat } });
    },
    showPost(ob) {
      this.$store.commit("post_detail_set", ob);
      this.$store.dispatch("checkPostDetail");
      this.post_datail = this.$store.getters.post_detail;
      this.showLoading = true;
      this.$router.push(`/details/${ob.id}`).then(() => {
        this.$nextTick(() => {
          window.scrollTo(0, 0);
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        });
      });
      this.getSamePosts(ob.id);
    },
    handleImageError(event) {
      event.target.src = "../assets/img/noimage.jpg";
    },
    setRequestVistHandler() {
      if (
        this.post_datail &&
        this.post_datail.user_id &&
        this.$store.state.auth.loggedIn &&
        this.parent_id == 0
      ) {
        if (this.post_datail.user_id == this.$store.state.auth.uid) {
          this.newComment = "";
          toast(
            "امکان ثبت درخواست بازدید برای آگهی‌های متعلق به خودتان وجود ندارد.",
            {
              type: "error",
            },
          );
          return;
        }
      }
      this.requestLoading = true;
      this.helperPost("save-visit", {
        post_id: this.post_datail.id,
      })
        .then((response) => {
          if (response.data.result == 1) {
            toast(response.data.msg, {
              type: "success",
            });
          } else {
            toast(response.data.msg, {
              type: "error",
            });
          }
          this.requestLoading = false;
        })
        .catch((error) => {
          console.log(error);
          toast("مشکلی پیش آمده؛ مجددا امتحان کنید..", {
            type: "error",
          });
          this.requestLoading = false;
        });
    },
  },
  watch: {
    // ۱. fix کردن syntax — جدا کردن دو watcher
    "$route.params.id": {
      handler() {
        const newId = this.$route.params.id;
        const routeType = this.$route.params.type;
        if (newId) {
          localStorage.removeItem("post_detail");

          this.destroyMap();

          if (routeType == "archived") {
            this.loadArchivePost(newId);
          } else {
            this.load_postInfo(newId);
          }
        }
      },
      immediate: false,
    },

    "$store.state.c_set": {
      handler() {
        this.destroyMap();
        this.mapInitStarted = true;
        this.$nextTick(() => {
          if (!this.mapInitialized) {
            this.initializeMap();
          }
        });
      },
      immediate: true,
    },

    showLoading(newVal) {
      if (newVal == true) {
        document.documentElement.scrollTo({ top: 0, behavior: "instant" });
        setTimeout(() => {
          if (this.post_datail) {
            this.showLoading = false;
          }
        }, 1500);
      }
    },
  },

  async mounted() {
    // همیشه ابتدا لودینگ را نمایش بده
    this.showLoading = true;

    this.authDetails = JSON.parse(localStorage.getItem("auth"));
    const routeId = this.$route.params.id;
    const storedPost = JSON.parse(localStorage.getItem("post_detail"));

    // بررسی وجود داده در localStorage
    const hasLocalData = storedPost && routeId && routeId == storedPost.id;
    if (routeId) {
      if (hasLocalData) {
        // اگر داده در localStorage موجود است، 1 ثانیه صبر کن سپس داده را نمایش بده
        setTimeout(async () => {
          this.$store.dispatch("checkPostDetail");
          this.post_datail = this.$store.getters.post_detail;
          console.log("second", this.$store.getters.post_detail);
          if (
            this.post_datail.photo_galleries &&
            this.post_datail.photo_galleries.length
          )
            this.showgallary = true;
          this.urlToShare =
            "https://shomalamlak.ir/details/" + this.post_datail.id;
          await this.load_postComment("first");
          this.getSamePosts(storedPost.id);

          // فراخوانی متدهای نقشه
          setTimeout(() => {
            // this.getmounted();
            this.initializeMap();
          }, 500);

          this.showLoading = false; // لودینگ را مخفی کن
          setTimeout(() => {
            localStorage.removeItem("post_detail");
          }, 2500);
        }, 1000); // 1 ثانیه تاخیر
      } else {
        localStorage.removeItem("post_detail");
        const routeType = this.$route.params.type;
        if (routeType == "archived") {
          this.loadArchivePost(routeId);
        } else {
          this.load_postInfo(routeId);
        }
        this.getSamePosts(routeId);
      }
    } else {
      // اگر routeId وجود ندارد، بررسی کنیم آیا داده در localStorage هست
      if (storedPost) {
        // اگر داده در localStorage موجود است، 1 ثانیه صبر کن سپس داده را نمایش بده
        setTimeout(async () => {
          this.$store.dispatch("checkPostDetail");
          this.post_datail = this.$store.getters.post_detail;
          console.log("second", this.$store.getters.post_detail);
          if (
            this.post_datail.photo_galleries &&
            this.post_datail.photo_galleries.length
          )
            this.showgallary = true;
          this.urlToShare =
            "https://shomalamlak.ir/details/" + this.post_datail.id;
          await this.load_postComment("first");
          this.getSamePosts(storedPost.id);

          // فراخوانی متدهای نقشه
          setTimeout(() => {
            // this.getmounted();
            this.initializeMap();
          }, 500);

          this.showLoading = false; // لودینگ را مخفی کن
        }, 1000); // 1 ثانیه تاخیر
      } else {
        // اگر هیچ داده‌ای در localStorage نیست، لودینگ تا دریافت از سرور نمایش داده می‌شود
        // showLoading قبلاً true شده است
      }
    }

    await nextTick();
    this.loadMoreTrigger = this.$refs.loadMoreTrigger;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.load_postComment();
        }
      },
      { threshold: 1.0 },
    );
    if (this.loadMoreTrigger) {
      observer.observe(this.loadMoreTrigger);
    }

    // Wait for post_datail to be populated
    await nextTick();
    const leafLetTitle = document.querySelector(".leaflet-right");
    if (leafLetTitle) {
      leafLetTitle.style = "z-index: 900 !important;";
    }
    await this.$nextTick();
  },
  beforeUnmount() {
    // Clean up
    this.commentSheet = false;
    this.destroyMap();
  },
};
</script>

<style lang="scss" scoped>
@import url("@/assets/style.scss");

.accommodation-pdp-specification-icon i {
  font-size: 24px;
}

.accommodation-pdp-specification-icon {
  margin-top: 0 !important;
}

.ClassPositionsLayers {
  width: 100%;
  height: 468px;
  border-radius: 8px;
}

.desktopComments {
  .j-list-section-title__content {
    display: block !important;
    width: 100%;
  }
  .j-list-section-title__title {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 16px;
  }
}

.commentTitle {
  font-family: "iranyekanB", sans-serif;
  font-weight: 500;
  font-size: 24px;

  span {
    font-size: 18px;
  }
}

.showCommentsModalDesktop {
  padding: 0 12px;
  border: 2px solid #0096c7;
  height: 38px;
  color: #0096c7;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.commentsList {
  width: 96%;
  margin: 0 auto;
  padding: 24px 0;

  .commentInputWrapper {
    display: flex;
    margin-bottom: 24px;

    .inputUserProfile {
      flex-shrink: 0;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: #000;
      margin-left: 16px;
    }

    &.newCommentInput {
      padding-bottom: 24px;
      border-bottom: 1px solid #eee;

      .commentInput {
        .addCommentInput {
          input {
            border: 1px solid #ddd;
            padding: 12px 8px;
            border-radius: 6px;
            font-size: 1rem;

            &:focus {
              border: 1px solid #0096c7;
            }
          }

          &::after {
            display: none;
          }
        }
      }
    }

    .commentInput {
      flex: 1;

      .addCommentInput {
        position: relative;
        margin-bottom: 8px;
        input {
          display: block;
          width: 100%;
          padding: 2px 0;
          border-bottom: 1px solid #ccc;
        }

        &::after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          display: block;
          width: 100%;
          height: 1.5px;
          background: #0096c7;
          transform: scaleX(0);
          transition: all 0.2s;
        }

        &.focus {
          &::after {
            transform: scaleX(1);
          }
        }
      }

      .commentInputBtns {
        width: 100%;
        display: flex;
        justify-content: left;

        .commentBtn,
        .cancleBtn {
          display: flex;
          align-items: center;
          height: 36px;
          padding: 0 16px;
          font-size: 14px;
          line-height: 36px;
          border-radius: 18px;
          background: #0096c7;
          color: #fff;
          margin-right: 6px;
          cursor: pointer;
        }

        .cancleBtn {
          background: #e5f0ff;
          color: #0096c7;
        }

        .commentBtn.disabled {
          pointer-events: none;
          cursor: none;
          opacity: 0.4;
        }
      }
    }
  }

  .commentThumb {
    display: flex;
    margin-bottom: 16px;

    .commentProfile {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: #0096c7;
      flex-shrink: 0;
      margin-left: 16px;
    }

    .commentContent {
      flex: 1;

      .commentHeader {
        display: flex;
        align-items: center;
        gap: 8px;
        .userName {
          font-family: "iranyekanB", sans-serif;
          font-weight: 500;
          font-size: 14px;
          margin-bottom: 2px;
        }

        .commentDate {
          font-family: "iranyekan", sans-serif;
          font-size: 12px;
          color: #999;
        }
      }

      .commentText {
        font-family: "iranyekan", sans-serif;
        font-size: 13px;
        font-weight: 400;
        line-height: 1.25rem;
        margin-bottom: 2px;
      }

      .commentBtns {
        display: flex;
        margin-bottom: 4px;

        .commentLikesBtn {
          display: flex;

          .likeBtnWrapper {
            display: flex;

            .likeNum {
              margin-left: 8px;
              margin-right: 2px;
              padding-top: 4px;
              font-size: 14px;
            }
          }

          .likeBtn,
          .disLikeBtn {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            svg.commentBtnIcon {
              font-size: 14px;
              stroke: #0096c7 !important;
              path {
                stroke: #0096c7 !important;
              }
            }

            &:hover {
              background: #e5f0ff;
            }
          }
        }

        .commentReplyBtn {
          margin-right: 8px;
          margin-top: 6px;
          padding: 0 8px;
          font-size: 13px;
          line-height: 24px;
          border-radius: 16px;
          cursor: pointer;
          background: #e5f0ff;
          color: #0096c7;

          &:hover {
            background: #e5f0ff;
            color: #0096c7;
          }
        }
      }

      .commentInputWrapper {
        display: none;

        &.show {
          display: flex;
          margin-top: 6px;
        }
        padding-right: 4px;
        margin-bottom: 2px;
        .inputUserProfile {
          width: 24px;
          height: 24px;
        }
      }

      .commentsReplyToggler {
        .commentsReplyToggleBtn {
          padding: 0 16px;
          width: fit-content;
          height: 36px;
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 13px;
          border-radius: 16px;
          color: #0096c7;
          cursor: pointer;

          &:hover {
            background: #e5f0ff;
          }
        }
      }

      .commentsReply {
        display: none;

        &.show {
          display: block;
        }
        .commentThumb {
          width: 100%;
          .commentProfile {
            width: 24px;
            height: 24px;
            margin-right: 16px;
            margin-top: 8px;
          }
        }
      }
    }
  }
}

.pdp-host-info {
  .postDetailsContainer {
    width: 100%;
    .detailsColumn {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &:first-of-type {
        display: none;
      }

      .pdp-host-info-content {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }
    }
  }
}

.product-amenities-list {
  display: flex;
  align-items: flex-start;
  // gap: 8px;
  flex-wrap: wrap;

  .product-amenities-list__item {
    display: flex;
    align-items: center;
    width: auto !important;
    padding: 4px 0;
    color: #000;
    border-radius: 6px;
    margin: 0 !important;
    font-size: 14px;

    &:not(:last-of-type) {
      &::after {
        content: "-";
        margin: 0 8px;
        display: block;
      }
    }
  }
}

.commentsDestopBody {
  width: 100%;
}

.loginMessage {
  font-size: 0.9rem;
}

.addCommentForm {
  position: relative;
  margin-bottom: 16px;

  .commentSubmit {
    position: absolute;
    left: 32px;
    top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    padding: 0 12px;
    border-radius: 6px;
    font-size: 14px;
    z-index: 2;
    background: #e6e6e6;
    color: #000;
    pointer-events: none;
    cursor: not-allowed;
    &.active {
      background: #0096c7;
      color: #fff;
      pointer-events: auto;
      cursor: pointer;
    }
  }

  .form__group {
    position: relative;
    padding: 15px 0 0;
    margin-top: 10px;
    width: 94%;
    margin: 0 auto;
  }

  .form__field {
    position: relative;
    z-index: 1;
    font-family: "iranyekan", sans-serif;
    width: 100%;
    border: 0;
    border-bottom: 2px solid #9b9b9b;
    outline: 0;
    font-size: 1rem;
    color: #000;
    padding: 7px 0;
    background: transparent;
    transition: border-color 0.2s;

    &::placeholder {
      color: transparent;
    }
    &:focus {
      outline: none !important;
      border-top: none !important;
      border-left: none !important;
      border-right: none !important;
    }

    &:placeholder-shown ~ .form__label {
      font-size: 1rem;
      cursor: text;
      top: 20px;
    }
  }

  .form__label {
    position: absolute;
    top: 24px;
    display: block;
    transition: 0.2s;
    font-size: 14px;
    color: #9b9b9b;
  }

  .form__field:focus {
    ~ .form__label {
      position: absolute;
      top: 0;
      display: block;
      transition: 0.2s;
      font-size: 1rem;
      color: #0096c7;
    }
    padding-bottom: 6px;
    border: 3px solid #0096c7;
  }
  .form__field {
    &:required,
    &:invalid {
      box-shadow: none;
    }
  }
}

.ShowCommandBoxesMyBottomSheet {
  height: 500px;
  overflow-y: hidden;

  .dentMessageToCommentSpace {
    height: 60px;
  }

  .dentMessageToComment {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    height: 60px;
    background: #ffffff;
    display: flex;
    gap: 10px;
    align-items: center;
    padding: 10px;
    border-top: 1px solid #ededed;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.05);
    .mobileNewCommentInput {
      width: 100%;
      height: 40px;
      width: 100%;
      height: 40px;
      background: #f5f5f5;
      border-radius: 5px;
      input {
        background: transparent;
        height: 100%;
        padding: 0 10px;
        font-size: 1rem;
      }
    }
  }

  .dentMessageToComment {
    height: 60px;
    display: flex;
    gap: 12px;
    align-items: center;

    .sendCommentBtnWrapper {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #0096c7;
      border-radius: 12px;
      flex-shrink: 0;

      .sendCommentBtn {
        color: #fff !important;
      }

      span.loader {
        margin: 0 !important;
      }
    }

    .mobileNewCommentInput {
      width: 100%;
      height: 40px;
      width: 100%;
      height: 40px;
      background: #f5f5f5;
      border-radius: 12px;
      input {
        background: transparent;
        height: 100%;
        padding: 0 10px;
        font-size: 1rem;
      }
    }

    .cancleReply {
      position: absolute;
      left: 22px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 13px;
      padding: 6px 8px;
      border: 1px solid #0096c7;
      background: #e5f0ff;
      color: #0096c7;
      border-radius: 24px;
    }
  }

  .AllChildCommentRefSheet {
    margin: auto;
    width: 95%;
    padding: 10px;
    position: relative;
  }

  .ChildCommentRefSheetVg {
    display: flex;
    align-items: center;
    justify-content: space-between;
    svg {
      cursor: pointer;
    }
  }

  .ChildCommentRefSheet {
    display: flex;
    align-items: center;
    gap: 15px;
    height: 50px;
  }

  .ReplayChildCommentRefSheet {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 50px;
    margin-top: 20px;
    .TitleChildCommentRefSheet {
      border-radius: 10px;
      h1 {
        font-size: 0.85rem;
      }

      p {
        font-size: 0.8rem;
        color: #333;
      }
    }

    .ImageChildCommentRefSheet {
      height: 30px;
      width: 30px;
      border-radius: 100%;
      overflow: hidden;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .ImageChildCommentRefSheet {
    height: 34px;
    width: 34px;
    border-radius: 100%;
    overflow: hidden;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .TitleChildCommentRefSheet {
    h1 {
      font-size: 0.9rem;
      font-weight: 500;
      color: rgb(21, 21, 77);
      font-family: "iranyekanB";
    }

    p {
      font-size: 0.75rem;
      color: #555;
      font-family: "iranyekan";
    }
  }
}

.mobileTitle {
  display: none;
}

.postDetailsContainer {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;

  .pdp-host-info-content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .pdp-host-info-content__title {
      // font-size: 1.15rem;
      // margin-bottom: 0;
      // text-align: left;
    }
  }
}

.titleWrapper {
  display: flex;
  align-items: center;
  gap: 16px;

  .uploadedDate {
    margin: 0 !important;
  }
}

.uploadedDate {
  width: fit-content;
  position: relative;
  margin-top: 16px;
  font-size: 0.8rem;
  padding-right: 12px;
  background: rgb(229 240 255);
  color: #0096c7;
  padding: 6px 10px;
  border-radius: 24px;
}

.contactOptionBoxesSection {
  display: none;
}

.comment-card__content {
  padding: 1rem;

  .comment-card__text {
    font-size: 0.8rem !important;
  }
}

.ShowClickFollow {
  line-height: 26.5px;
  padding: 0 16px;
  width: 138px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  text-align: center;
  border-radius: 12px;
  background: #0096c7;
  border: 1px solid #0096c7;
  transition: 0.1s ease-in-out;
  cursor: pointer;
  color: #fff;

  &.unfollow {
    background: #f00;
    color: #fff;
    border: 1px solid #f00;
  }
}

.mapboxContainer {
  .map {
    height: 336px;
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #0096c7;
  }

  .postLocation {
    font-size: 14px;
    margin-top: -24px;
    margin-bottom: 28px;
  }
}

.house-marker {
  background: none;
  border: none;
}

.DetailWithShow {
  padding-top: 54px;
  padding-bottom: 82px;
}

.ol-viewport.ol-touch div {
  &:nth-of-type(4) {
    z-index: 9 !important;
  }
}

.mobildeShowReplyBtn {
  position: relative;
  font-size: 12px;
  margin-right: 40px;
  margin-top: 10px;
  margin-bottom: 6px;
  color: #0096c7;
  padding-right: 12px;
  cursor: pointer;

  &::before {
    content: "";
    display: block;
    width: 6px;
    height: 1px;
    background: #0096c7;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}

.repliesList {
  margin-top: -10px;
}

.mobileNocomments {
  padding: 48px 0;
  font-size: 1rem;
  color: #777;
  text-align: center;
}

.pdp-host-info-content__titleWrapper {
  display: flex;
  flex-direction: column;

  h2 {
    margin: 0 !important;
  }

  .followersNum {
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    color: rgb(111, 114, 133);
  }
}

.contactBoxInfo {
  display: none;
}
.accommodation-description-content {
  & > div {
    line-height: 24px;
  }
}

.accommodation-pdp-specification-description {
  flex-wrap: wrap;
}

.accommodation-pdp-specification-description__item {
  svg {
    width: 24px;
    height: 24px;
  }
}

@media (max-width: 1000px) {
  .contactBoxInfo {
    display: block;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    width: 100%;
    height: 64px;
    padding: 12px 16px;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
    z-index: 999;

    .contactBoxInfoWrapper {
      width: 100%;
      height: 100%;
      display: grid;
      align-items: center;
      justify-content: space-between;
      grid-template-columns: repeat(3, 1fr);
      gap: 12px;

      &.twoColumn {
        grid-template-columns: 1fr 1fr;

        .contactInfoBtn {
          &.btnLight {
            &:last-child {
              background: #0096c7;
              color: #fff;
            }
          }
        }
      }

      .contactInfoBtn {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #0096c7;
        border-radius: 12px;
        font-size: 0.9rem;

        &:not(.btnLight) {
          background: #0096c7;
          color: #fff;
        }

        &.btnLight {
          background: #fff;
          color: #0096c7;
        }
      }
    }
  }
  .DetailWithShow {
    padding-top: 0;
  }
  .desktopComments {
    display: none !important;
  }
  .accommodation-pdp-content__main > * {
    padding: 16px 0 24px;
  }

  .accommodation-pdp-content__main > :not(:last-child) {
    border-bottom: 1px solid #eee;
  }

  .accommodation-pdp-specifications-heading {
    margin-bottom: 16px;
  }

  .mapboxContainer {
    .map {
      height: 246px;
    }

    .postLocation {
      margin-top: -10px;
      margin-bottom: 24px;
    }
  }

  .pdp-host-info-content {
    &.detailsWrapper {
      gap: 12px !important;

      .pdp-host-info-content__titleWrapper {
        flex-grow: 1;
        .pdp-host-info-content__title {
          width: 100%;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .ShowClickFollow {
    flex-shrink: 0;
    line-height: 26.5px;
    padding: 0 16px;
    width: auto;
    height: 32px;
    text-align: center;
    border-radius: 12px;
    background: #0096c7;
    border: 1px solid #0096c7;
    transition: 0.1s ease-in-out;
    cursor: pointer;
    color: #fff;
    font-size: 12px;

    &.unfollow {
      background: #f00;
      color: #fff;
      border: 1px solid #f00;
    }
  }

  .accommodation-pdp-head {
    display: none !important;
  }

  .accommodation-pdp-content {
    display: block !important;
  }

  .comment-card-info {
    padding: 0.25rem;
  }

  .accommodation-pdp-specifications__container > :not(:last-child) {
    margin-bottom: 1.35rem !important;
  }

  .accommodation-pdp-specification-content__title {
    font-size: 0.9rem !important;
    margin: 0 !important;
    font-family: "iranyekan", sans-serif;
  }

  .accommodation-pdp-specification-description__item {
    font-family: "iranyekan", sans-serif;
    font-size: 0.8rem;
    font-weight: 400;
  }

  .selectedLocations {
    flex-wrap: wrap;
    row-gap: 4px;
  }

  .comment-card-guest-info__avatar {
    width: 2.5rem;
    height: 2.5rem;
  }

  .comment-card-guest-info__title {
    font-size: 1rem !important;
  }

  .comment-card-guest-info__desc {
    font-size: 0.75rem !important;
    font-family: "iranyekanL", sans-serif;
    margin-top: -4px;
  }

  .accommodation-pdp-specifications-heading__title,
  .product-amenities-heading__title,
  .accommodation-description-heading__title,
  .accommodation-landmarks-heading__title {
    font-size: 1rem !important;
  }

  .accommodation-description-content {
    font-size: 12px;
    display: block !important;

    & > div {
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
    }
  }

  .product-amenities-heading,
  .accommodation-description-heading {
    margin-bottom: 16px !important;
  }

  .contactOptionBoxesSection {
    display: block;
    padding: 16px 0 94px;
  }

  .postTitleContainer {
    position: relative;
    width: 100%;

    .postTitle {
      width: 100%;
      font-family: "iranyekanB", sans-serif;
      font-size: 1.25rem;
      max-width: calc(100% - 72px);
    }

    .postPrice {
      width: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      .postPriceWrapper {
        font-family: "iranyekanL", sans-serif;
        font-size: 0.9rem;
      }

      .uploadedDate {
        margin: 0 !important;
        position: absolute;
        left: 0;
        top: 6px;
      }
    }
  }

  .contactOptionBoxes {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .optionBox {
      width: 48%;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      background: #0096c7;
      border-radius: 6px;
      color: #fff;
      font-size: 16px;
    }
  }

  .pdp-host-info {
    &.mobileTitle {
      display: block;
    }
    .postDetailsContainer {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 12px;

      .pdp-host-info-avatar {
        width: 3rem;
        height: 3rem;
      }

      .pdp-host-info-content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .pdp-host-info-content__title {
          font-size: 1rem;
          margin-bottom: 0;
          text-align: left;
        }
      }
    }
  }
  .accommodation-pdp-sidebar-calendar {
    p {
      font-size: 1rem !important;
    }
  }
}

.sendCommentBtn {
  width: 32px;
  height: 32px;
  background: transparent;
  font-size: 20px;
  color: #0096c7;
  display: flex;
  align-items: center;
  justify-content: center;
}

.accommodation-landmark {
  justify-content: right !important;
  gap: 4px !important;
  align-items: center;
}

.loader {
  height: 20px;
  width: 20px;
  margin-top: 0 !important;
}

/* Add any needed bottom sheet styles */
.vue-bottom-sheet {
  z-index: 1000;
}

.product-amenities
  .mapboxContainer
  .map.leaflet-container
  .leaflet-control-container
  .leaflet-bottom.leaflet-right {
  z-index: 900 !important;

  :deep(.leaflet-bottom) {
    z-index: 900 !important;
  }
}

.optionButtonsWrapper {
  margin-top: 24px;
  margin-bottom: -12px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;

  &.singleColumn {
    grid-template-columns: 100%;

    .reportBtn {
      width: 60%;
      margin-inline: auto;
      background: #0096c7;
      color: #fff;
    }
  }

  .requestBtn,
  .reportBtn {
    width: 100%;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    font-size: 0.8rem;
    font-family: "iranyekanB", sans-serif;
    transition: all 0.25s;
    cursor: pointer;

    &:hover {
      transform: translateY(-4px);
    }
  }

  .requestBtn {
    background: #0096c7;
    color: #fff;
  }

  .reportBtn {
    background: transparent;
    color: #0096c7;
    border: 1px solid #0096c7;
  }
}

.pdp-host-info
  .postDetailsContainer
  .pdp-host-info-content
  .pdp-host-info-content__title {
  text-align: right !important;
}

.postCreatoreDetails {
  display: block !important;

  .postBranchDetails {
    .detailsThumb {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 12px;
      margin-top: 16px;
      padding-right: 12px;
      position: relative;

      &::before {
        content: "";
        display: block;
        width: 1px;
        height: 16px;
        background: #333;
        position: absolute;
        top: -16px;
        right: 32px;
      }

      .thumbPic {
        width: 42px;
        height: 42px;
        flex-shrink: 0;

        img {
          width: 100%;
          height: 100%;
          display: block;
          object-fit: cover;
          border-radius: 50%;
          border: 1px solid #131b1f;
        }
      }

      .thumbContent {
        font-size: 0.95rem;
      }
    }
  }
}

@media (min-width: 1000px) {
  .reportFixedBtn {
    display: none;
  }
}

@media (max-width: 1000px) {
  .reportFixedBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    padding: 0 16px;
    width: fit-content;
    background: #0096c7;
    color: #fff;
    font-family: "iranyekanB", sans-serif;
    font-size: 0.7rem;
    border-radius: 8px;
    margin: -8px auto -8px;
  }

  .dark {
    .pdp-host-info-avatar__image {
      border-color: #ababab;
    }
    .postCreatoreDetails {
      .postBranchDetails {
        .detailsThumb {
          &::before {
            background: #ababab;
          }

          .thumbPic {
            img {
              border-color: #ababab;
            }
          }
        }
      }
    }
  }

  .postCreatoreDetails {
    display: block !important;

    .postBranchDetails {
      .detailsThumb {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 12px;
        margin-top: 16px;
        padding-right: 6.5px;
        position: relative;

        &::before {
          content: "";
          display: block;
          width: 1px;
          height: 16px;
          background: #333;
          position: absolute;
          top: -16px;
          right: 24px;
        }

        .thumbPic {
          width: 36px;
          height: 36px;
          flex-shrink: 0;

          img {
            width: 100%;
            height: 100%;
            display: block;
            object-fit: cover;
            border-radius: 50%;
            border: 1px solid #131b1f;
          }
        }

        .thumbContent {
          font-size: 0.875rem;
        }
      }
    }
  }
}

.desktopPhoneNumber {
  font-size: 0.9rem;
}

.districtsThumb {
  &:not(:last-child) {
    align-items: center;
    display: inline-flex;
    &::after {
      content: "•";
      font-size: 0.625rem;
      margin: 0.125rem 0.3125rem 0;
    }
  }
}

.districtsIcon {
  svg {
    width: 24px;
    height: 24px;
  }
}

.dark {
  .accommodation-pdp-head .title h1,
  .specifications .city-province {
    color: #fff;
  }

  .titleWrapper {
    .uploadedDate {
      background: rgb(63, 70, 79);
    }
  }

  .postTitleContainer .postPrice .uploadedDate {
    background: rgb(63, 70, 79);
  }
}

@media (min-width: 1000px) {
  .reportBtnWrapper {
    display: none;
  }
}

.reportBtnWrapper {
  margin-top: 24px;

  .repostBtn {
    width: 124px;
    height: 42px;
    background: #0096c7;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 0.95rem;
    margin-left: auto;
    margin-right: auto;
  }
}

.requestPrice {
  span {
    display: block;
  }
}

.requestPriceRent {
  & > span {
    display: block;
  }

  span {
    margin-left: 6px;
  }
}

.accommodation-pdp-specification-description__item {
  &:last-child {
    &::after {
      display: none;
    }
  }
}
</style>
